<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, sortBy } from "lodash";
import groupBy from "lodash/groupBy";
import Swal from "sweetalert2";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import RatingScale from "@/components/modals/rating-scale.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Multiselect from "vue-multiselect";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "PMT Secretariat Review",
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    AttachmentModal,
    RatingScale,
    PrintOptions,
    UploadPopover,
    Multiselect,
    RawData,
  },
  data() {
    return {
      title: "PMT Secretariat Review",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "PMT Secretariat Review",
          active: true,
        },
      ],
      movFields: [
        {
          key: "mode",
          label: "Mode",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "attachments",
          label: "Attachments",
        },
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
        includeThousandsSeparator: false,
      }),
      duData: [],
      selectedDu: null,
      targetData: [],
      filter: "",
      loading: false,
      viewingApi: false,
      selectedDU: null,
      modalTitle: "",
      addApi: false,
      apiLoading: false,
      apiData: [],
      uploadTitle: "",
      opcrs: [],
      selectedOPCR: "",
      selectedTargetData: null,
      ratingBusy: false,
      measurementData: [],
      rating: null,
      actualSelected: null,
      tabIndex: 0,
      returnForm: {
        id: null,
        quarter: "",
        remarks: "",
        withExpiry: false,
        returnExpiry: "",
      },
      tabOptions: [
        "Strategic Priority",
        "Core Functions",
        "Mandatory Support Function",
      ],
      attachmentLoading: true,
      attachments: [],
      movData: [],
      returnRemarks: [],
      returnRemarksTitle: "",
      fileSearch: "",
      attachmentQuarter: 0,
      returnTPMS: true,
      returnQuarters: false,
      attWActions: false,
      indexOffice: -1,
      indexKpi: -1,
      indexTarget: -1,
      // Add data properties for Print OPCR By Filter functionality
      filteredReport: false,
      campusList: [],
      printType: "Campus", // Default to Campus/Cluster type
      selectedCampusPrint: null,
      selectedClusterPrint: null,
      selectedClassificationPrint: null, selectedPrexcPrint: [],
      prexcList: [],
      clusterOptions: [],
    };
  },
  async mounted() {
    this.pageLoader(true);
    await this.getCampusTemplate(
      this.$store.state.data.selectedCampus.id,
      this.$store.state.data.cycle
    );
    this.pageLoader(false);
  },
  computed: {
    groupedPrexc() {
      var array = [];
      var group = groupBy(this.prexcList, "prexcClassificationId");
      for (const key in group) {
        array.push({
          id: key,
          classification: group[key][0].prexcClassification.classification,
          prexcList: group[key]
        });
      }
      return array;
    }
  },
  methods: {
    groupedTargets(props) {
      var array = [];
      var x = groupBy(props, "mainTarget.indicatorItemId");
      for (const xKey in x) {
        var indicatorItemId = xKey;
        var y = groupBy(x[xKey], "mainTarget.indicatorItem.indicatorItemName");
        for (const yKey in y) {
          var indicatorItemName = yKey;
          var z = groupBy(
            y[yKey],
            "mainTarget.indicatorItem.indicatorItemClassification.classification"
          );
          for (const zKey in z) {
            array.push({
              indicatorItemId: indicatorItemId,
              indicatorItemName: indicatorItemName,
              indicatorItemClassification: zKey,
              details: z[zKey],
              showTargets: false,
            });
          }
        }
      }
      return array;
    },
    filteredKpi(type) {
      let data = this.targetData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("MANDATORY");
      });
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.details.filter((targetItem) => {
            return targetItem.searchKey
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }).length;
        });
      }
      return data;
    },
    filteredTarget(props) {
      let data = props.details;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.searchKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    getCampusTemplate(campus, cycle) {
      if (this.tabIndex == 0) {
        this.getUnPostedDu(cycle, campus);
      } else if (this.tabIndex == 1) {
        this.getPostedDu(cycle, campus);
      } else if (this.tabIndex == 2) {
        this.getSubmittedDu(cycle, campus);
      } else if (this.tabIndex == 3) {
        this.getCompletedDu(cycle, campus);
      }
    },
    changeCycle(cycle, campus) {
      if (this.tabIndex == 0) {
        this.getUnPostedDu(cycle, campus);
      } else if (this.tabIndex == 1) {
        this.getPostedDu(cycle, campus);
      } else if (this.tabIndex == 2) {
        this.getSubmittedDu(cycle, campus);
      } else if (this.tabIndex == 3) {
        this.getCompletedDu(cycle, campus);
      }
    },
    getDeadline(cycle) {
      this.$store
        .dispatch("submissiondeadline/GetSubmissionDeadline", cycle)
        .then((res) => {
          this.duData.forEach((deliveryUnit) => {
            deliveryUnit.accomplishmentDeadline = null;
            deliveryUnit.returnDeadline = null;
            deliveryUnit.accomplishmentDeadline = res.data.find(
              (x) =>
                x.referenceType.toLowerCase() === "accomplishment - du" &&
                x.type.toLowerCase() === "planning" &&
                x.referenceId === deliveryUnit.deliveryUnitId
            );
            if (!deliveryUnit.accomplishmentDeadline) {
              deliveryUnit.accomplishmentDeadline = res.data.find(
                (x) =>
                  x.referenceType.toLowerCase() === "accomplishment" &&
                  x.type.toLowerCase() === "planning" &&
                  x.referenceId === 0
              );
            }
            deliveryUnit.returnDeadline = res.data.find(
              (x) =>
                x.referenceType.toLowerCase() === "returned - du" &&
                x.type.toLowerCase() === "planning" &&
                x.referenceId === deliveryUnit.deliveryUnitId
            );
            if (!deliveryUnit.returnDeadline) {
              deliveryUnit.returnDeadline = res.data.find(
                (x) =>
                  x.referenceType.toLowerCase() === "returned" &&
                  x.type.toLowerCase() === "planning" &&
                  x.referenceId === 0
              );
            }
          });
        });
    },
    checkDeadline(row) {
      if (this.setDeadline(row) && this.setDeadline(row) < new Date())
        return true;
      else return false;
    },
    setDeadline(row) {
      if (row.accomplishmentDeadline && row.returnDeadline) {
        if (
          new Date(row.accomplishmentDeadline.deadline) <
          new Date(row.returnDeadline.deadline)
        ) {
          return new Date(row.returnDeadline.deadline);
        } else return new Date(row.accomplishmentDeadline.deadline);
      } else if (row.accomplishmentDeadline && !row.returnDeadline) {
        return new Date(row.accomplishmentDeadline.deadline);
      } else if (!row.accomplishmentDeadline && row.returnDeadline) {
        return new Date(row.returnDeadline.deadline);
      } else return null;
    },
    getUnPostedDu(cycle, campus) {
      this.$store
        .dispatch("target/GetDuWithUnPostedTarget", {
          cycle: cycle,
          campusId: campus,
        })
        .then((res) => {
          res.data.map((item) => {
            item.tabSelect = "";
            item.tabIndex = 0;
            item.accomplishmentDeadline = null;
            item.returnDeadline = null;
          });
          this.duData = sortBy(res.data, "deliveryUnitName");
          this.getDeadline(cycle);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getPostedDu(cycle, campus) {
      this.$store
        .dispatch("target/GetDuWithPostedTarget", {
          cycle: cycle,
          campusId: campus,
        })
        .then((res) => {
          res.data.map((item) => {
            item.tabSelect = "";
            item.tabIndex = 0;
            item.accomplishmentDeadline = null;
            item.returnDeadline = null;
          });
          this.duData = sortBy(res.data, "deliveryUnitName");
          this.getDeadline(cycle);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getSubmittedDu(cycle, campus) {
      this.$store
        .dispatch("target/GetDuWithSubmittedTarget", {
          cycle: cycle,
          campusId: campus,
        })
        .then((res) => {
          res.data.map((item) => {
            item.tabSelect = "Strategic Priority";
            item.tabIndex = 0;
            item.accomplishmentDeadline = null;
            item.returnDeadline = null;
          });
          this.duData = sortBy(res.data, "deliveryUnitName");
          this.getDeadline(cycle);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getCompletedDu(cycle, campus) {
      this.$store
        .dispatch("target/GetDuWithCompletedTarget", {
          cycle: cycle,
          campusId: campus,
        })
        .then((res) => {
          res.data.map((item) => {
            item.tabSelect = "Strategic Priority";
            item.tabIndex = 0;
            item.accomplishmentDeadline = null;
            item.returnDeadline = null;
          });
          this.duData = sortBy(res.data, "deliveryUnitName");
          this.getDeadline(cycle);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getUnPostedTargets(row) {
      this.loading = true;
      await this.$store
        .dispatch("target/GetUnPostedTargetByDu", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: row.deliveryUnitId,
        })
        .then((res) => {
          res.data.map((item) => {
            item.description = item.remarks ? item.remarks : "";
            item.showDetails = false;
            item.deliveryUnit = cloneDeep(row);
            item.searchKey = `${item.mainTarget.indicatorItem.indicatorItemName} ${item.remarks}`;
          });
          this.targetData = this.groupedTargets(
            sortBy(res.data, "description")
          );
          this.setTabSelect(row);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async getPostedTargets(row) {
      this.loading = true;
      await this.$store
        .dispatch("target/GetPostedTargetByDu", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: row.deliveryUnitId,
        })
        .then((res) => {
          let checkedData = [];
          res.data.map((item) => {
            item.description = item.remarks ? item.remarks : "";
            item.showDetails = false;
            item.deliveryUnit = cloneDeep(row);
            item.searchKey = `${item.mainTarget.indicatorItem.indicatorItemName} ${item.remarks}`;
            // if(item.actual[0].status && !item.actual[0].status.toLowerCase().includes('return')){
            //   checkedData.push(item)
            // }
            checkedData.push(item);
          });
          this.targetData = this.groupedTargets(
            sortBy(checkedData, "description")
          );
          this.setTabSelect(row);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async getSubmittedTargets(row) {
      this.loading = true;
      await this.$store
        .dispatch("target/GetSubmittedTargetByDu", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: row.deliveryUnitId,
        })
        .then((res) => {
          res.data.map((item) => {
            item.description = item.remarks ? item.remarks : "";
            item.showDetails = false;
            item.deliveryUnit = cloneDeep(row);
            item.qualityOptions = [];
            item.efficiencyOptions = [];
            item.timelinessOptions = [];
            item.searchKey = `${item.mainTarget.indicatorItem.indicatorItemName} ${item.remarks}`;
          });
          this.targetData = this.groupedTargets(
            sortBy(res.data, "description")
          );
          this.setTabSelect(row);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async getCompletedTargets(row) {
      this.loading = true;
      await this.$store
        .dispatch("target/GetCompletedTargetByDu", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: row.deliveryUnitId,
        })
        .then((res) => {
          res.data.map((item) => {
            item.description = item.remarks ? item.remarks : "";
            item.showDetails = false;
            item.deliveryUnit = cloneDeep(row);
            item.qualityOptions = [];
            item.efficiencyOptions = [];
            item.timelinessOptions = [];
            item.searchKey = `${item.mainTarget.indicatorItem.indicatorItemName} ${item.remarks}`;
          });
          this.targetData = this.groupedTargets(
            sortBy(res.data, "description")
          );
          this.setTabSelect(row);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async openTargets(row) {
      this.targetData = [];
      this.filter = "";
      row.tabSelect = "Strategic Priority";
      row.tabIndex = 0;
      if (this.tabIndex == 0) {
        await this.getUnPostedTargets(row);
      } else if (this.tabIndex == 1) {
        await this.getPostedTargets(row);
      } else if (this.tabIndex == 2) {
        await this.getSubmittedTargets(row);
      } else if (this.tabIndex == 3) {
        await this.getCompletedTargets(row);
      }
    },
    setTabSelect(row) {
      row.tabIndex = 0;
      row.tabSelect = this.checkTab("Strategic Priority")
        ? "Strategic Priority"
        : this.checkTab("Core Functions")
          ? "Core Functions"
          : "Mandatory Support Function";
    },
    checkTab(type) {
      let data = this.targetData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("MANDATORY");
      });
      return data.length > 0 ? true : false;
    },
    validatorFeedback(feedback) {
      if (feedback == "") return "";
      if (feedback == "LSD") return "Lacking supporting documents (LSD)";
      if (feedback == "NTI") return "No Target Indicated (NTI)";
      if (feedback == "NAI") return "No Accomplishment Indicated (NAI)";
      if (feedback == "AIT")
        return "Accomplishment Inconsistent with Target (AIT)";
      if (feedback == "ES") return "Evidence Sufficient (ES)";
      if (feedback == "EIS") return "Evidence Insufficient (EIS)";
      if (feedback == "LSE") return "Label Submitted Evidence (LSE)";
      if (feedback == "NEA") return "No Evidence Attached (NEA)";
      if (feedback == "NAVI") return "No Absolute Value Indicated (NAVI)";
      if (feedback == "KNF") return "KPI not found in approved OPCR (KNF)";
      if (feedback == "KFD")
        return "KPI Found in approved OPCR but Deleted (KFD)";
      if (feedback == "FPD") return "For PMTs Deliberation (FPD)";
    },
    typeNotifCount(type) {
      let data = this.targetData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("MANDATORY");
      });
      var count = 0;
      data.forEach((target) => {
        count = count + target.details.length;
      });
      return count;
    },
    viewActualAPIs(row) {
      this.selectedDU = row;
      this.modalTitle = "View APIs";
      this.$bvModal.show("api-modal");
      this.addApi = false;
      this.viewingApi = true;
      this.getOPCRS(row, "actual");
    },
    async getOPCRS(row, type) {
      await this.$store
        .dispatch("opcr/GetAllOpcr", {
          deliveryUnitId: this.selectedDU.deliveryUnitId,
          cycle: this.$store.state.data.cycle,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.opcrs = res.data;
          if (res.data.length > 0) {
            this.getAPI(row, type, res.data[0].id);
            this.selectedOPCR = res.data[0].id;
          }
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getAPI(row, type, opcrId) {
      this.apiLoading = true;
      this.apiData = [];
      if (type === "template") {
        await this.$store
          .dispatch("planningtemplateapi/GetPlanningTemplateApi", row.id)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.map((item) => {
              item.editMode = false;
            });
            this.apiData = res.data;
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        await this.$store
          .dispatch("api/GetApiByTarget", { targetId: row.id, opcrId })
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (!res.data.map) {
              return;
            }
            res.data.map((item) => {
              item.editMode = false;
            });
            this.apiData = res.data;
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
      this.apiLoading = false;
    },
    resetApi() {
      this.api = {
        id: 0,
        planningTemplateDeliveryUnitId: 0,
        name: "",
        description: "",
        apiTypeId: "",
        priority: false,
        apiType: {
          type: "",
        },
      };
      this.$v.api.$reset();
    },
    addMoreApi() {
      this.addApi = !this.addApi;
      if (this.addApi) {
        this.resetApi();
      }
    },
    async viewQuarterAttachment(quarter, id, type) {
      this.attachmentLoading = true;
      this.modalTitle = `Quarter ${quarter} Attachment`;
      this.$bvModal.show("modal-quarterAttachments");
      if (type == "Mandatory Support Function") {
        this.attWActions = true;
      } else {
        this.attWActions = false;
      }
      this.attachmentQuarter = quarter;
      await this.getMOV(id);
      await this.movData.forEach((item) => {
        item.attachments = [];
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: id,
            type: `Quarter ${quarter} Files: ${item.mode}`,
          })
          .then((res) => {
            item.attachments = item.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              `Something went wrong! - getting quarter ${quarter} files.`,
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: id,
            type: `Quarter ${quarter} Files: ${item.id}`,
          })
          .then((res) => {
            item.attachments = item.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              `Something went wrong! - getting quarter ${quarter} files.`,
              "error"
            );
          });
        item.uploadOptions = {
          type: `Quarter ${quarter} Files: ${item.id}`,
          placement: "left",
          folder: "Planning",
        };
      });
      await setTimeout(() => {
        this.attachmentLoading = false;
      }, 500);
    },
    viewCatchupAttachment(id) {
      this.uploadTitle = `Catchup Plan / Justification Attachment`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `Catchup Plan Attachment`,
        placement: "left",
        folder: "Planning",
      });
      this.$refs.attachmentModal.getData(id);
      this.$bvModal.show("upload-attachment-modal");
    },
    async getMOV(id) {
      this.movData = [];
      await this.$store.dispatch("mov/GetMOVByTarget", id).then(async (res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        res.data.forEach((item) => {
          item.attachments = [];
          item.addDocu = false;
          item.uploadOptions = null;
        });
        this.movData = res.data;
        this.movData.push({
          id: `others-${id}`,
          targetId: id,
          target: null,
          mode: "OTHERS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null,
        });
        this.movData.push({
          id: `catchup-${id}`,
          targetId: id,
          target: null,
          mode: "CATCHUP PLANS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null,
        });
      });
    },
    viewReturnRamarks(pmeLogs, pmtLogs) {
      pmeLogs = pmeLogs ? pmeLogs : [];
      let logs = pmeLogs.concat(pmtLogs);
      this.returnRemarksTitle = "View Logs";
      this.returnRemarks = logs.sort((a, b) => new Date(b.remarksDate) - new Date(a.remarksDate));
      this.returnRemarks.forEach((item) => {
        item.dateWTime = this.formatDateWithTime(new Date(item.remarksDate));
        item.splitted = item.dateWTime.split(" at ");
        item.Employee = item.employee;
        item.Remarks = item.remarks;
      });
      this.$bvModal.show("return-remarks-modal");
    },
    async returnTPMSFunc(row){
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to return this target TPMS?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff9f43",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return it!",
      }).then(async (result) => {
        if (result.value) {
          await this.$store
            .dispatch("ratingscale/ReturnRatingScale", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully returned!", "success");
              row.ratingScaleStatus = "RETURNED";
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    postTarget(row) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to post this target on behalf of the delivery unit?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.value) {
          let targetSelected = cloneDeep(row);
          if (row.actual.length > 0) {
            targetSelected.scoreQuality = 1;
            targetSelected.scoreEfficiency = 1;
            targetSelected.scoreTimeliness = 1;
            targetSelected.evaluationScoreQuality = 1;
            targetSelected.evaluationScoreEfficiency = 1;
            targetSelected.evaluationScoreTimeliness = 1;
            this.updateTarget(targetSelected, false);
            this.$store
              .dispatch("actual/PostActual", row.actual[0].id)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                let indexOffice = this.duData.findIndex(
                  (item) => item.deliveryUnitId == targetSelected.deliveryUnitId
                );
                let indexKpi = this.targetData.findIndex(
                  (item) =>
                    item.indicatorItemId == targetSelected.indicatorItemId
                );
                let indexTarget = this.targetData[indexKpi].details.findIndex(
                  (item) => item.id == targetSelected.id
                );
                this.targetData[indexKpi].details.splice(indexTarget, 1);
                if (this.targetData[indexKpi].details.length == 0)
                  this.targetData.splice(indexKpi, 1);
                if (this.targetData.length == 0)
                  this.duData.splice(indexOffice, 1);
                this.showToast("Successfully posted!", "success");
              })
              .catch((err) => {
                return this.showToast(
                  "Something went wrong - posting target!",
                  "error"
                );
              });
          } else {
            let actual = {
              targetId: targetSelected.id,
              q1: 0,
              q1Remarks: "",
              q2: 0,
              q2Remarks: "",
              q3: 0,
              q3Remarks: "",
              q4: 0,
              q4Remarks: "",
              catchUpPlans: "",
              finalRemarks: "",
            };
            this.$store
              .dispatch("actual/CreateActual", actual)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                targetSelected.scoreQuality = 1;
                targetSelected.scoreEfficiency = 1;
                targetSelected.scoreTimeliness = 1;
                targetSelected.evaluationScoreQuality = 1;
                targetSelected.evaluationScoreEfficiency = 1;
                targetSelected.evaluationScoreTimeliness = 1;
                this.updateTarget(targetSelected, false);
                this.$store
                  .dispatch("actual/PostActual", res.data.id)
                  .then((res) => {
                    if (res.data.error) {
                      return this.showToast(res.data.errorMessage, "error");
                    }
                    let indexOffice = this.duData.findIndex(
                      (item) =>
                        item.deliveryUnitId == targetSelected.deliveryUnitId
                    );
                    let indexKpi = this.targetData.findIndex(
                      (item) =>
                        item.indicatorItemId == targetSelected.indicatorItemId
                    );
                    let indexTarget = this.targetData[
                      indexKpi
                    ].details.findIndex((item) => item.id == targetSelected.id);
                    this.targetData[indexKpi].details.splice(indexTarget, 1);
                    if (this.targetData[indexKpi].details.length == 0)
                      this.targetData.splice(indexKpi, 1);
                    if (this.targetData.length == 0)
                      this.duData.splice(indexOffice, 1);
                    this.showToast("Successfully posted!", "success");
                  });
              })
              .catch((err) => {
                return this.showToast(
                  "Something went wrong - posting target!",
                  "error"
                );
              });
          }
        }
      });
    },
    onUnpostQuarter() {
      this.submitted = true;
      if (
        this.returnForm.remarks == "" ||
        (this.returnForm.withExpiry &&
          (this.returnForm.returnExpiry == "" ||
            this.returnForm.returnExpiry == null))
      ) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to return this quarter.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, return it!",
      }).then(async (result) => {
        if (result.value) {
          this.returnForm.returnExpiry = this.getDate(
            this.returnForm.returnExpiry
          );
          this.$store
            .dispatch("actual/UnpostActualByQuarter", this.returnForm)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.actualSelected[`q${this.returnForm.quarter}PostedBy`] = null;
              if (
                !this.actualSelected.q1PostedBy &&
                !this.actualSelected.q2PostedBy &&
                !this.actualSelected.q3PostedBy &&
                !this.actualSelected.q4PostedBy &&
                this.actualSelected.status != "POSTED"
              ) {
                this.targetData[this.indexKpi].details.splice(
                  this.indexTarget,
                  1
                );
                if (this.targetData[this.indexKpi].details.length == 0)
                  this.targetData.splice(this.indexKpi, 1);
                if (this.targetData.length == 0)
                  this.duData.splice(this.indexOffice, 1);
              }
              this.$bvModal.hide("return-quarter-modal");
              this.showToast("Successfully returned!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
          this.submitted = false;
        }
      });
    },
    unpostQuarter(row, du, quarter) {
      // if (this.checkDeadline(du)) {
      //   Swal.fire({
      //     title: "Cannot proceed.",
      //     text: "The current return deadline has already passed. Please adjust it to a later date.",
      //     icon: "error",
      //     confirmButtonColor: "#7367f0",
      //     confirmButtonText: "Close",
      //   });
      //   return;
      // }
      this.actualSelected = row.actual[0];
      this.submitted = false;
      this.indexOffice = this.duData.findIndex(
        (item) => item.deliveryUnitId == du.deliveryUnitId
      );
      this.indexKpi = this.targetData.findIndex(
        (item) => item.indicatorItemId == row.indicatorItemId
      );
      this.indexTarget = this.targetData[this.indexKpi].details.findIndex(
        (item) => item.id == row.id
      );
      this.returnForm = {
        id: row.actual[0].id,
        quarter: quarter,
        remarks: "",
        withExpiry: this.setDeadline(du) ? true : false,
        returnExpiry: this.setDeadline(du),
      };
      this.modalTitle = `Return Quarter ${quarter}`;
      this.$bvModal.show("return-quarter-modal");
    },
    async unpostAllQuarters() {
      await this.$store
        .dispatch("actual/UnpostActualByQuarter", {
          id: this.returnForm.id,
          quarter: 1,
          remarks: this.returnForm.remarks,
          withExpiry: this.returnForm.withExpiry,
          returnExpiry: this.returnForm.returnExpiry,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.actualSelected.actual[0].q1PostedBy = null;
        });
      await this.$store
        .dispatch("actual/UnpostActualByQuarter", {
          id: this.returnForm.id,
          quarter: 2,
          remarks: this.returnForm.remarks,
          withExpiry: this.returnForm.withExpiry,
          returnExpiry: this.returnForm.returnExpiry,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.actualSelected.actual[0].q2PostedBy = null;
        });
      await this.$store
        .dispatch("actual/UnpostActualByQuarter", {
          id: this.returnForm.id,
          quarter: 3,
          remarks: this.returnForm.remarks,
          withExpiry: this.returnForm.withExpiry,
          returnExpiry: this.returnForm.returnExpiry,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.actualSelected.actual[0].q3PostedBy = null;
        });
      await this.$store
        .dispatch("actual/UnpostActualByQuarter", {
          id: this.returnForm.id,
          quarter: 4,
          remarks: this.returnForm.remarks,
          withExpiry: this.returnForm.withExpiry,
          returnExpiry: this.returnForm.returnExpiry,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.actualSelected.actual[0].q4PostedBy = null;
        });
    },
    async updateTarget(row, withToast) {
      await this.$store
        .dispatch("target/UpdateTarget", row)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          if (withToast) this.showToast("Successfully saved!", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    submitTarget(row) {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to send this target for PMT review",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, send it!",
      }).then(async (result) => {
        if (result.value) {
          await this.updateTarget(row, false);
          this.$store
            .dispatch("target/SubmitTarget", {
              id: row.id,
              body: "Submitted by PMT Secretariat",
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let indexOffice = this.duData.findIndex(
                (item) => item.deliveryUnitId == row.deliveryUnitId
              );
              let indexKpi = this.targetData.findIndex(
                (item) => item.indicatorItemId == row.indicatorItemId
              );
              let indexTarget = this.targetData[indexKpi].details.findIndex(
                (item) => item.id == row.id
              );
              this.targetData[indexKpi].details.splice(indexTarget, 1);
              if (this.targetData[indexKpi].details.length == 0)
                this.targetData.splice(indexKpi, 1);
              if (this.targetData.length == 0)
                this.duData.splice(indexOffice, 1);
              this.showToast("Successfully submitted!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be submitted!", "error");
            });
        }
      });
    },
    async onReturnTarget() {
      this.submitted = true;
      if (
        this.returnForm.remarks == "" ||
        (this.returnForm.withExpiry &&
          (this.returnForm.returnExpiry == "" ||
            this.returnForm.returnExpiry == null))
      ) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to return this target to delivery unit",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, return it!",
      }).then(async (result) => {
        if (result.value) {
          this.returnForm.returnExpiry = this.getDate(
            this.returnForm.returnExpiry
          );
          if (this.returnTPMS) {
            await this.returnEvaluation();
          }
          if (this.returnQuarters) {
            await this.unpostAllQuarters();
          }
          setTimeout(async () => {
            await this.$store
              .dispatch("actual/UnpostActual", this.returnForm)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.targetData[this.indexKpi].details.splice(
                  this.indexTarget,
                  1
                );
                if (this.targetData[this.indexKpi].details.length == 0)
                  this.targetData.splice(this.indexKpi, 1);
                if (this.targetData.length == 0)
                  this.duData.splice(this.indexOffice, 1);
                this.$bvModal.hide("return-modal");
                this.submitted = false;
                this.showToast("Successfully returned!", "success");
              })
              .catch((err) => {
                this.showToast("Something went wrong!", "error");
              });
          }, this.returnQuarters ? 1500 : 500);
        }
      });
    },
    returnTarget(row, du) {
      // if (this.checkDeadline(du)) {
      //   Swal.fire({
      //     title: "Cannot proceed.",
      //     text: "The current return deadline has already passed. Please adjust it to a later date.",
      //     icon: "error",
      //     confirmButtonColor: "#7367f0",
      //     confirmButtonText: "Close",
      //   });
      //   return;
      // }
      this.actualSelected = row;
      this.submitted = false;
      this.indexOffice = this.duData.findIndex(
        (item) => item.deliveryUnitId == du.deliveryUnitId
      );
      this.indexKpi = this.targetData.findIndex(
        (item) => item.indicatorItemId == row.indicatorItemId
      );
      this.indexTarget = this.targetData[this.indexKpi].details.findIndex(
        (item) => item.id == row.id
      );
      this.selectedTargetData = cloneDeep(row);
      this.returnForm = {
        id: row.actual[0].id,
        remarks: "",
        withExpiry: this.setDeadline(du) ? true : false,
        returnExpiry: this.setDeadline(du),
      };
      this.returnTPMS = false;
      this.returnQuarters = false;
      this.modalTitle = `Return Target`;
      this.$bvModal.show("return-modal");
    },
    async returnEvaluation() {
      await this.$store
        .dispatch("ratingscale/ReturnRatingScale", this.selectedTargetData.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
        });
    },
    deleteDuplicateTarget(row) {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to delete this target.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          let actualId = row.actual[row.actual.length - 1].id;
          this.$store
            .dispatch("actual/DeleteActual", actualId)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.getCampusTemplate(
                this.$store.state.data.selectedCampus.id,
                this.$store.state.data.cycle
              );
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    getAnnualTarget(row, isPercentage) {
      if (isPercentage) {
        if (row.q4 > 0) {
          return row.q4;
        }
        if (row.q3 > 0) {
          return row.q3;
        }
        if (row.q2 > 0) {
          return row.q2;
        }
        if (row.q1 > 0) {
          return row.q1;
        }
        return 0;
      } else {
        return row.q1 + row.q2 + row.q3 + row.q4;
      }
    },
    checkDuplicate(row) {
      if (row.actual.length > 1) return true;
      else return false;
    },
    calcAve(scoreQuality, scoreEfficiency, scoreTimeliness) {
      let sum =
        parseFloat(scoreQuality) +
        parseFloat(scoreEfficiency) +
        parseFloat(scoreTimeliness);

      var count = 0;
      if (parseFloat(scoreQuality) != 0) count++;
      if (parseFloat(scoreEfficiency) != 0) count++;
      if (parseFloat(scoreTimeliness) != 0) count++;

      let ave = sum / count;
      return isNaN(ave) ? 0 : ave.toFixed(2);
    },
    getInitialDate(y) {
      return this.formatDateWithTime(new Date(
        y.actual[0].jsonRemarks?.filter(x => x.remarks === 'Accomplishment Posted')
          .sort((a, b) => new Date(a.remarksDate) - new Date(b.remarksDate))[0]?.remarksDate
        || y.actual[0].datePosted)
      )
    },
    viewAttachments(row) {
      this.uploadTitle = `Target Attachment`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `Target`,
        placement: "left",
        folder: "Planning",
      });
      this.$refs.attachmentModal.getData(row.id);
      this.$bvModal.show("upload-attachment-modal");
    },
    async getAttachments(row) {
      this.modalTitle = `View Attachments`;
      this.$bvModal.show("modal-allAttachments");
      this.attachmentLoading = true;
      this.attachments = [];
      row.mov = [];
      await this.getMOV(row.id);
      row.mov = this.movData;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Target",
        })
        .then((res) => {
          this.attachments = this.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      await this.movData.forEach((item) => {
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.mode}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.id}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.mode}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.id}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.mode}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.id}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.mode}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.id}`,
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
      });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Catchup Plan Attachment",
        })
        .then((res) => {
          this.attachments = this.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast(
            "Something went wrong! - getting catchup plan files",
            "error"
          );
        });
      await setTimeout(() => {
        this.attachmentLoading = false;
      }, 500);
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    uploadedDocument(response, movId) {
      let index = this.movData.findIndex((item) => item.id == movId);
      this.movData[index].attachments.push(response);
    },
    removeQuarterFile(id, parentId) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let movIndex = this.movData.findIndex(
                (item) => item.id == parentId
              );
              let fileIndex = this.movData[movIndex].attachments.findIndex(
                (item) => item.id == id
              );
              this.movData[movIndex].attachments.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be remove!", "error");
            });
        }
      });
    },
    searchDocu(type) {
      let data = type
        ? this.attachments.filter((item) => {
          return item.type == type;
        })
        : this.attachments;
      if (this.fileSearch.trim() != "" && this.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(this.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    searchQuarterDocu(modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = this.attachments.filter((item) => {
        return item.type == modeType;
      });
      let idDocu = this.attachments.filter((item) => {
        return item.type == idType;
      });
      let data = modeDocu.concat(idDocu);
      if (this.fileSearch.trim() != "" && this.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(this.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    filterDocuByType(attachments, modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = attachments.filter((item) => {
        return item.type.includes(modeType);
      });
      let idDocu = attachments.filter((item) => {
        return item.type.includes(idType);
      });
      let data = modeDocu.concat(idDocu);
      return data;
    },
    getApis() {
      if (!this.selectedOPCR) return (this.apiData = []);
      this.getAPI(this.selectedDU, "actual", this.selectedOPCR);
    },
    autoGrowTemplate(element, size) {
      element.style.height = `${size}px`;
      element.style.height = `${element.scrollHeight}px`;
    },
    autoGrow(element, size) {
      element.target.style.height = `${size}px`;
      element.target.style.height = `${element.target.scrollHeight}px`;
    },
    getPerformanceRating(row, type) {
      this.$refs.RatingScale.setMeasurement(row, type);
    },
    printTPMS(officeId) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/TPMS",
        routeVariables: [this.$store.state.data.cycle, officeId],
      });
      this.$bvModal.show("print-options-modal");
    },
    printRatedOPCR(officeId) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/Rated/Opcr",
        routeVariables: [this.$store.state.data.cycle, officeId],
      });
      this.$bvModal.show("print-options-modal");
    },
    printFilteredRatedOPCR() {
      if (this.printType === "Campus" && this.selectedCampusPrint) {
        let campusId = this.selectedCampusPrint ? this.selectedCampusPrint.Id : 0;
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus",
          routeVariables: [this.$store.state.data.cycle, campusId]
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === 'Cluster' && this.selectedClusterPrint) {
        let clusterId = this.selectedClusterPrint.id;
        let campusIds = this.selectedCampusPrint.Id ? [this.selectedCampusPrint.Id] : this.selectedCampusPrint.map(c => c.Id);
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus/Cluster",
          routeVariables: [this.$store.state.data.cycle, clusterId],
          body: campusIds
        });
        this.$bvModal.show("print-options-modal");
      } else if (
        this.printType === 'PREXC' &&
        this.selectedClassificationPrint &&
        this.selectedPrexcPrint.length > 0
      ) {
        let campusId = this.selectedCampusPrint ? this.selectedCampusPrint.Id : 0;
        let classificationId = this.selectedClassificationPrint.id;
        let prexcIdArray = this.selectedPrexcPrint;

        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus",
          routeVariables: [
            this.$store.state.data.cycle,
            campusId,
            classificationId
          ],
          body: prexcIdArray
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === "SubmissionDates") {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Target/Submission/Date",
          routeVariables: [this.$store.state.data.cycle],
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === "Summary") {
        let campusId = this.selectedCampusPrint ? this.selectedCampusPrint.Id : 0;
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Target/Submission/Summary",
          routeVariables: [this.$store.state.data.cycle, campusId],
        });
        this.$bvModal.show("print-options-modal");
      } else return;
      this.filteredReport = false;
    },
    async renderSelection() {
      this.selectedCampusPrint = {
        CampusName: this.$store.state.data.selectedCampus.campusName,
        Id: this.$store.state.data.selectedCampus.id
      }
      this.selectedClusterPrint = this.selectedDu && this.selectedDu.clusterName ? {
        id: this.selectedDu.clusterId,
        clusterName: this.selectedDu.clusterName
      } : null;
      this.selectedClassificationPrint = null;
      this.selectedPrexcPrint = []; this.printType = "Campus"; // Reset to default
      this.campusList = await this.$store.state.decrypt.campusAccessList();

      // Get clusters for the selected campus
      await this.$store
        .dispatch("cluster/GetCluster")
        .then((res) => {
          this.clusterOptions = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });

      await this.$store
        .dispatch("prexc/GetPrexc")
        .then((res) => {
          this.prexcList = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });

      this.filteredReport = true;
    },

    disabledRangeFrom(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
  },
};
</script>
<template>
  <Layout @changeCycle="changeCycle($event, $store.state.data.selectedCampus.id)"
    @changeCampus="getCampusTemplate($event.id, $store.state.data.cycle)">
    <PageHeader :title="title" :items="items" />
    <!-- Api -->
    <b-modal id="api-modal" :title="modalTitle" size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
      <div class="row">
        <div class="col-md-6">
          <ul>
            <li>
              <b class="font-size-14 me-1">Main Target:</b>
              <span class="font-size-16"><u>{{ selectedDU && selectedDU.description }}</u></span>
            </li>
            <li>
              <b class="font-size-14 me-1">Delivery Unit:</b>
              <span class="text-warning font-size-16">{{
                selectedDU && selectedDU.deliveryUnit.deliveryUnitName
              }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <label for="" class="mb-0 me-2">OPCRs:</label>
          <select class="form-control" v-model="selectedOPCR" @change="getApis">
            <option value="">Select OPCR</option>
            <option v-for="x in opcrs" :key="x.id" :value="x.id">
              {{ x.title }}
            </option>
          </select>
        </div>
      </div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th width="40%">
              <div class="d-flex">
                API Name/Description
                <button type="button" class="btn btn-warning btn-sm px-2 py-0 ms-1" v-if="!viewingApi"
                  @click="addMoreApi">
                  <template v-if="!addApi">
                    <i class="bx bx-plus"></i>Add More
                  </template>
                  <template v-else> <i class="bx bx-x"></i>Cancel </template>
                </button>
              </div>
            </th>
            <!-- <th :width="viewingApi && '20%'">API Type</th> -->
            <th v-if="!viewingApi" class="text-center" :width="!addApi ? '90px' : '10%'">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!apiLoading && apiData.length == 0 && !addApi">
            <td :colspan="!viewingApi ? 3 : 2" class="text-center">
              No Data Found
            </td>
          </tr>
          <tr v-if="apiLoading">
            <td :colspan="!viewingApi ? 3 : 2" class="text-center">
              Loading...
            </td>
          </tr>
          <template v-if="!apiLoading && apiData.length > 0">
            <template v-for="x in apiData">
              <tr :key="`parent-not-edit-${x.id}`" v-if="!x.editMode">
                <td>
                  <div>{{ x.name }}</div>
                  <small>{{ x.description }}</small>
                </td>
                <!-- <td>
                  {{ x.apiType ? x.apiType.type : 'N/A' }}
                </td> -->
                <td class="align-middle" v-if="!viewingApi">
                  <div class="d-flex justify-content-center align-items-center">
                    <button type="button" title="Edit" class="btn btn-link p-0 font-size-16 me-1" @click="updateApi(x)">
                      <i class="bx bx-edit"></i>
                    </button>
                    <button type="button" title="Delete" class="btn btn-link p-0 font-size-16" @click="deleteApi(x)">
                      <i class="bx bx-trash text-danger"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr :key="`parent-edit-${x.id}`" v-else>
                <td>
                  <input type="text" class="form-control mb-3" v-model="api.name" placeholder="Enter API Name" :class="{
                    'is-invalid': submitted && $v.api.name.$error,
                  }" />
                  <textarea rows="3" class="form-control" v-model="api.description" placeholder="Enter API Description"
                    :class="{
                      'is-invalid': submitted && $v.api.description.$error,
                    }" />
                </td>
                <td>
                  <input type="text" class="form-control cursor-pointer" v-model="api.apiType.type"
                    placeholder="Click to Select Api Type" readonly @click="showApiType" :class="{
                      'is-invalid': submitted && $v.api.apiTypeId.$error,
                    }" />
                </td>
                <td class="text-center" v-if="!viewingApi">
                  <button type="button" class="btn btn-success" @click="saveApi">
                    <i class="bx bx-save"></i> Save
                  </button>
                  <button type="button" class="btn btn-clear" @click="x.editMode = false">
                    <i class="bx bx-x"></i> Cancel
                  </button>
                </td>
              </tr>
            </template>
          </template>
          <template v-if="addApi">
            <tr>
              <td>
                <input type="text" class="form-control mb-3" v-model="api.name" placeholder="Enter API Name" :class="{
                  'is-invalid': submitted && $v.api.name.$error,
                }" />
                <textarea rows="3" class="form-control" v-model="api.description" placeholder="Enter API Description"
                  :class="{
                    'is-invalid': submitted && $v.api.description.$error,
                  }" />
              </td>
              <td>
                <input type="text" class="form-control cursor-pointer" v-model="api.apiType.type"
                  placeholder="Click to Select Api Type" readonly @click="showApiType" :class="{
                    'is-invalid': submitted && $v.api.apiTypeId.$error,
                  }" />
              </td>
              <td class="text-center">
                <button type="button" class="btn btn-success" @click="saveApi">
                  <i class="bx bx-save"></i> Save
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </b-modal>
    <!-- Return Quarter -->
    <b-modal id="return-quarter-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <form @submit.prevent="onUnpostQuarter">
        <!-- <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input
              type="checkbox"
              id="autoGenerate"
              checked="checked"
              class="form-check-input"
              v-model="returnForm.withExpiry"
            /><label for="autoGenerate" class="form-check-label">
              With Deadline
            </label>
          </div>
          <b-collapse :visible="returnForm.withExpiry">
            <div v-if="returnForm.withExpiry">
              <label for="returnExpiry">Deadline </label>
              <date-picker
                id="returnExpiry"
                v-model="returnForm.returnExpiry"
                :first-day-of-week="1"
                lang="en"
                :disabled-date="disabledRangeFrom"
                placeholder="Enter Deadline..."
                :class="{
                  'is-invalid':
                    submitted &&
                    returnForm.withExpiry &&
                    returnForm.returnExpiry == '',
                }"
              ></date-picker>
              <div
                v-if="
                  submitted &&
                  returnForm.withExpiry &&
                  returnForm.returnExpiry == ''
                "
                class="invalid-feedback"
              >
                <span>This value is required.</span>
              </div>
            </div>
          </b-collapse>
        </div> -->
        <div class="mb-3">
          <label class="form-label">Remarks</label>
          <textarea rows="3" autocomplete="off" class="form-control" placeholder="Enter Remarks..."
            v-model="returnForm.remarks">
      </textarea>
        </div>
        <div class="d-flex float-end">
          <button type="submit" class="btn btn-primary">Return Quarter</button>
        </div>
      </form>
    </b-modal>
    <!-- Return Actual -->
    <b-modal id="return-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop
      no-close-on-esc>
      <form @submit.prevent="onReturnTarget">
        <!-- <div class="text-warning font-size-14 mb-3">
          Instruction Note: Simply clicking the "Return" button allows the delivery units to update MOV (Measure of Value) 
          attachments, while checking "Return Performance Rubric" enables the update of the QET (Quality Evaluation Tool) 
          rating. Additionally, checking "Return All Quarters" allows the update of the actual target value and remarks for 
          each quarter. Please ensure to select the appropriate options based on the updates required.
        </div> -->
        <!-- <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input
              type="checkbox"
              id="autoGenerate"
              checked="checked"
              class="form-check-input"
              v-model="returnForm.withExpiry"
            /><label for="autoGenerate" class="form-check-label">
              With Deadline
            </label>
          </div>
          <b-collapse :visible="returnForm.withExpiry">
            <div v-if="returnForm.withExpiry">
              <label for="returnExpiry">Deadline </label>
              <date-picker
                id="returnExpiry"
                v-model="returnForm.returnExpiry"
                :first-day-of-week="1"
                lang="en"
                :disabled-date="disabledRangeFrom"
                placeholder="Enter Deadline..."
                :class="{
                  'is-invalid':
                    submitted &&
                    returnForm.withExpiry &&
                    returnForm.returnExpiry == '',
                }"
              ></date-picker>
              <div
                v-if="
                  submitted &&
                  returnForm.withExpiry &&
                  returnForm.returnExpiry == ''
                "
                class="invalid-feedback"
              >
                <span>This value is required.</span>
              </div>
            </div>
          </b-collapse>
        </div> -->
        <div class="mb-3">
          <label class="form-label">Remarks</label>
          <textarea rows="3" autocomplete="off" class="form-control" placeholder="Enter Remarks..."
            v-model="returnForm.remarks" :class="{
              'is-invalid': submitted && returnForm.remarks == '',
            }">
      </textarea>
          <div v-if="submitted && returnForm.remarks == ''" class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="returnTPMS" checked="checked" class="form-check-input"
              v-model="returnTPMS" /><label for="returnTPMS" class="form-check-label">
              Return Performance Rubric
            </label>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="returnQuarters" checked="checked" class="form-check-input"
              v-model="returnQuarters" /><label for="returnQuarters" class="form-check-label">
              Return All Quarters
            </label>
          </div>
        </div>
        <div class="d-flex float-end">
          <button type="submit" class="btn btn-primary">Return Target</button>
        </div>
      </form>
    </b-modal>
    <!-- Attachments -->
    <b-modal id="modal-allAttachments" :title="modalTitle" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <div class="row mb-3">
        <div class="col-md-4">
          <input type="search" class="form-control" placeholder="Search Attachments" v-model="fileSearch"
            @input="searchDocu()" />
        </div>
      </div>
      <b-row class="mt-2">
        <b-col>
          <h5 v-if="attachmentLoading">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-center align-items-center ms-4 font-size-14">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </div>
          </h5>
          <h5 v-else-if="searchDocu().length == 0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span v-if="fileSearch">Search not found.</span>
                <span v-else>No document found.</span>
                <div class="d-flex justify-content-center align-items-center ms-4 font-size-14"
                  v-if="attachmentLoading">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </div>
          </h5>
          <div v-else>
            <div v-if="searchDocu('Target').length > 0" class="row mb-3">
              <div class="col-md-12">
                <b class="text-white font-size-14">Target Documents</b>
              </div>
              <div class="col-md-4" v-for="(z, index) in searchDocu('Target')" :key="z.id">
                <div class="position-relative cursor-pointer border mt-2 br-5 mb-2"
                  :style="`z-index: ${searchDocu('Target').length - index}`">
                  <div class="border p-3" @click="openDocument(z)">
                    <div>
                      <div class="avatar-xs me-3 mb-2">
                        <div class="avatar-title bg-transparent rounded">
                          <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                          <i v-if="z.fileType.includes('application')"
                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="overflow-hidden me-auto">
                          <h5 class="font-size-14 text-truncate mb-1">
                            {{ z.description }}
                          </h5>
                          <p class="text-muted mb-0">
                            {{
                              formatDateWithTime(new Date(z.dateTimeUploaded))
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="mov in movData" :key="mov.id" class="row">
              <div v-if="
                filterDocuByType(
                  searchDocu(),
                  `Files: ${mov.mode}`,
                  `Files: ${mov.id}`
                ).length > 0
              " class="mb-1">
                <b class="text-white font-size-14">{{ mov.mode }}</b>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 1 Files: ${mov.mode}`,
                  `Quarter 1 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 1 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 1 Files: ${mov.mode}`,
                  `Quarter 1 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 1 Files: ${mov.mode}`,
                    `Quarter 1 Files: ${mov.id}`
                  ).length - index
                    }`">
                    <div class="border p-3">
                      <div @click="openDocument(z)">
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 2 Files: ${mov.mode}`,
                  `Quarter 2 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 2 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 2 Files: ${mov.mode}`,
                  `Quarter 2 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 2 Files: ${mov.mode}`,
                    `Quarter 2 Files: ${mov.id}`
                  ).length - index
                    }`">
                    <div class="border p-3">
                      <div @click="openDocument(z)">
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 3 Files: ${mov.mode}`,
                  `Quarter 3 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 3 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 3 Files: ${mov.mode}`,
                  `Quarter 3 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 3 Files: ${mov.mode}`,
                    `Quarter 3 Files: ${mov.id}`
                  ).length - index
                    }`">
                    <div class="border p-3">
                      <div @click="openDocument(z)">
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 4 Files: ${mov.mode}`,
                  `Quarter 4 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 4 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 4 Files: ${mov.mode}`,
                  `Quarter 4 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 4 Files: ${mov.mode}`,
                    `Quarter 4 Files: ${mov.id}`
                  ).length - index
                    }`">
                    <div class="border p-3">
                      <div @click="openDocument(z)">
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3" v-if="searchDocu('Catchup Plan Attachment').length > 0">
              <div class="col-md-12">
                <b class="text-white font-size-14">Catchup Plan / Justification Documents</b>
              </div>
              <div class="col-md-4" v-for="(z, index) in searchDocu('Catchup Plan Attachment')" :key="z.id">
                <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchDocu('Catchup Plan Attachment').length - index
                  }`">
                  <div class="border p-3" @click="openDocument(z)">
                    <div>
                      <div class="avatar-xs me-3 mb-2">
                        <div class="avatar-title bg-transparent rounded">
                          <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                          <i v-if="z.fileType.includes('application')"
                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="overflow-hidden me-auto">
                          <h5 class="font-size-14 text-truncate mb-1">
                            {{ z.description }}
                          </h5>
                          <p class="text-muted mb-0">
                            {{
                              formatDateWithTime(new Date(z.dateTimeUploaded))
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Quarter Attachments -->
    <b-modal id="modal-quarterAttachments" :title="modalTitle" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col>
          <h5 v-if="attachmentLoading">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-center align-items-center ms-4 font-size-14">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </div>
          </h5>
          <div class="row mb-3" v-else>
            <div v-for="mov in movData" :key="mov.id">
              <div class="d-flex justify-content-between mb-2">
                <label class="text-white font-size-14">{{ mov.mode }}</label>
                <div v-if="attWActions">
                  <button type="button" @click="mov.addDocu = true" class="btn btn-sm btn-outline-info"
                    :id="`quarter-document${mov.id}`">
                    <i class="mdi mdi-upload fs-6"></i>
                    Upload Documents
                  </button>
                  <upload-popover :option="mov.uploadOptions" :sourceId="mov.targetId"
                    @uploaded="uploadedDocument($event, mov.id)" :showPV="mov.addDocu"
                    @closePopover="mov.addDocu = false" :dzId="`dropzone-target${mov.id}`"
                    :pvId="`quarter-document${mov.id}`"></upload-popover>
                </div>
              </div>
              <div class="border-bottom p-2 mb-3">
                <b v-if="
                  filterDocuByType(
                    mov.attachments,
                    `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                    `Quarter ${attachmentQuarter} Files: ${mov.id}`
                  ).length == 0
                ">
                  No document found.
                </b>
                <div class="row mb-3">
                  <div class="col-md-4" v-for="(z, index) in filterDocuByType(
                    mov.attachments,
                    `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                    `Quarter ${attachmentQuarter} Files: ${mov.id}`
                  )" :key="z.id">
                    <div class="position-relative cursor-pointer border br-5 mb-2" :style="`z-index: ${filterDocuByType(
                      mov.attachments,
                      `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                      `Quarter ${attachmentQuarter} Files: ${mov.id}`
                    ).length - index
                      }`">
                      <div class="border p-3">
                        <div>
                          <div class="float-end ms-2" v-if="attWActions">
                            <b-dropdown id="dropdown-dropleft" right variant="link"
                              toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                              menu-class="dropdown-menu-end" no-caret>
                              <template #button-content>
                                <i class="mdi mdi-dots-horizontal"></i>
                              </template>
                              <b-dropdown-item @click="openDocument(z)"><i
                                  class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                              <b-dropdown-item variant="danger" @click="removeQuarterFile(z.id, mov.id)"><i
                                  class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                            </b-dropdown>
                          </div>
                          <div @click="openDocument(z)">
                            <div class="avatar-xs me-3 mb-2">
                              <div class="avatar-title bg-transparent rounded">
                                <i v-if="z.fileType.includes('image')"
                                  class="mdi mdi-image font-size-24 text-purple"></i>
                                <i v-if="z.fileType.includes('application')"
                                  class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1">
                                  {{ z.description }}
                                </h5>
                                <p class="text-muted mb-0">
                                  {{
                                    formatDateWithTime(
                                      new Date(z.dateTimeUploaded)
                                    )
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Logs -->
    <b-modal id="return-remarks-modal" title="Accomplishment Logs" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <ul class="verti-timeline list-unstyled ms-3" v-for="(remark, index) in returnRemarks" :key="index">
        <li class="event-list" :class="{
          active: index == 0,
        }">
          <div class="event-timeline-dot">
            <i class="font-size-18" :class="index == 0
              ? 'bx bxs-right-arrow-circle bx-fade-right'
              : 'bx bx-right-arrow-circle'
              "></i>
          </div>
          <div class="media">
            <div class="me-3 mb-3">
              <h5 class="font-size-14 mb-0">
                {{ remark.splitted[0] }}
                <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
              <small>{{ remark.splitted[1] }}</small>
            </div>
            <div class="media-body">
              <div class="mb-0" style="line-height: 14px">
                {{ remark.Remarks }}
              </div>
              <div>
                <small>({{ remark.Employee }})</small>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </b-modal>
    <!-- Main -->
    <div class="position-relative">
      <b-tabs pills vertical v-model="tabIndex" nav-class="p-0" nav-wrapper-class="col-sm-2"
        content-class="pt-0 px-2 text-muted">
        <b-tab @click="
          getUnPostedDu(
            $store.state.data.cycle,
            $store.state.data.selectedCampus.id
          );
        selectedDu = null;
        ">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Unposted Targets</span>
          </template>
          <div v-if="tabIndex == 0">
            <div class="d-flex align-items-center gap-2">
              <multiselect id="deliveryUnit" v-model="selectedDu" track-by="deliveryUnitId" label="deliveryUnitName"
                placeholder="Select Delivery Unit..." :show-labels="false" :options="duData" :searchable="true"
                :multiple="false" :allow-empty="false" :close-on-select="true" @input="openTargets(selectedDu)">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.deliveryUnitName
                    }}</span><span v-if="props.option.submittedCount"
                      class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                        props.option.submittedCount
                      }}</span>
                  </div>
                  <div class="option__label">
                    <small>{{ props.option.campusName }}</small>
                  </div>
                </template>
              </multiselect>
              <!-- Print OPCR By Filter UI Button and Popover -->
              <div>
                <button type="button" class="btn btn-purple" :id="`select-report-${tabIndex}`" @click="renderSelection"
                  style="min-width: 170px !important;">
                  <i class="bx bx-printer me-1"></i>Print OPCR By Filter
                </button>
                <b-popover :target="`select-report-${tabIndex}`" triggers="click" placement="left"
                  :show.sync="filteredReport" custom-class="popover-report">
                  <template v-slot:title>
                    <div class="d-flex align-items-center justify-content-between" style="color: #222736">
                      <span>Filter</span>
                      <span class="bx bx-x font-size-14 cursor-pointer" @click="filteredReport = false"></span>
                    </div>
                  </template>
                  <div class="p-3">
                    <div class="mb-2">
                      <div class="mb-1">Print Report By</div>
                      <div class="mb-2">
                        <div class="d-flex gap-3">
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCampus"
                              value="Campus" v-model="printType" />
                            <label class="form-check-label" for="printTypeCampus">
                              {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCluster"
                              value="Cluster" v-model="printType" />
                            <label class="form-check-label" for="printTypeCluster">
                              Cluster
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypePrexc"
                              value="PREXC" v-model="printType" />
                            <label class="form-check-label" for="printTypePrexc">
                              PREXC Classification
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSD" value="SubmissionDates"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSD">
                              Submission Dates
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSum" value="Summary"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSum">
                              Summary
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                      <multiselect id="campus" v-model="selectedCampusPrint" track-by="Id" label="CampusName"
                        :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :show-labels="true" :options="campusList" :searchable="true"
                        :multiple="printType === 'Cluster' ? true : false" :allow-empty="false"
                        :close-on-select="printType === 'Cluster' ? false : true" @input="
                          selectedClassificationPrint = null;
                        selectedPrexcPrint = [];
                        ">
                      </multiselect>
                    </div>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'Cluster'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">Cluster</div>
                          <multiselect id="cluster" v-model="selectedClusterPrint" track-by="clusterName"
                            label="clusterName" placeholder="Select Cluster..." :show-labels="true"
                            :options="clusterOptions" :searchable="true" :multiple="false" :allow-empty="false"
                            :close-on-select="true">
                          </multiselect>
                        </div>
                      </div>
                    </b-collapse>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'PREXC'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">PREXC Classification</div>
                          <multiselect id="classification" v-model="selectedClassificationPrint" track-by="id"
                            label="classification" placeholder="Select PREXC Classification..." :show-labels="true"
                            :options="groupedPrexc" :searchable="true" :multiple="false" :allow-empty="true"
                            :close-on-select="true" @input="selectedPrexcPrint = []">
                          </multiselect>
                        </div>
                        <b-collapse :visible="selectedClassificationPrint != null">
                          <div v-if="selectedClassificationPrint != null" class="mb-2">
                            <div class="mb-1">PREXC</div>
                            <multiselect id="prexc" v-model="selectedPrexcPrint" track-by="id" label="prexcName"
                              placeholder="Select PREXC..." :show-labels="true"
                              :options="selectedClassificationPrint.prexcList" :searchable="true" :multiple="true"
                              :allow-empty="true" :close-on-select="false">
                            </multiselect>
                          </div>
                        </b-collapse>
                      </div>
                    </b-collapse>
                    <hr />
                    <button @click="printFilteredRatedOPCR()" type="button" class="btn btn-purple btn-sm btn-block">
                      <span class="font-size-13">
                        <i class="bx bx-printer me-1"></i>
                        Print Report
                      </span>
                    </button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div v-if="!selectedDu" class="mt-2">
              <b-alert :show="true" variant="info">
                <div>Please select a Delivery Unit.</div>
              </b-alert>
            </div>
            <div class="mt-2 pt-2" v-else>
              <div class="p-3 d-flex align-items-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div v-else class="position-relative">
                <div class="text-right position-absolute" style="right: 0">
                  <div class="d-flex align-items-center gap-2">
                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                      menu-class="dropdown-menu-end" no-caret>
                      <template #button-content>
                        <i class="bx bx-printer me-1"></i>
                        Reports
                      </template>
                      <b-dropdown-item @click="printTPMS(selectedDu.deliveryUnitId)">TPMS</b-dropdown-item>
                      <b-dropdown-item @click="printRatedOPCR(selectedDu.deliveryUnitId)">Rated OPCR</b-dropdown-item>
                    </b-dropdown>
                    <div id="tickets-table_filter" class="dataTables_filter">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input autocomplete="off" v-model="filter" type="search"
                          placeholder="Search KPI, Target..." class="form-control form-control-sm"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <b-tabs content-class="py-3 text-muted" v-model="selectedDu.tabIndex" nav-class="nav-tabs-custom">
                  <div v-for="(type, index) in tabOptions" :key="index">
                    <b-tab v-if="checkTab(type)" class="position-relative" @click="
                      filter = '';
                    selectedDu.tabSelect = type;
                    ">
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="mdi mdi-clock-time-four-outline"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">
                          {{ type }}
                          <span v-if="typeNotifCount(type) > 0">({{ typeNotifCount(type) }})</span>
                        </span>
                      </template>
                      <div v-if="selectedDu.tabSelect == type">
                        <div v-if="filteredKpi(type).length == 0" class="text-center">
                          <h5 v-if="filter">Search not found</h5>
                          <h5 v-else>No data available</h5>
                        </div>
                        <div role="tablist" v-for="kpi in filteredKpi(type)" :key="kpi.indicatorItemId">
                          <div class="border-bottom pb-3 mb-3">
                            <div class="d-flex align-items-center pb-3">
                              <div style="
                                  width: 10px;
                                  height: 10px;
                                  border-radius: 50%;
                                " class="bg-success ms-2 me-3"></div>
                              <b class="font-size-14">
                                KPI: {{ kpi.indicatorItemName }}
                              </b>
                            </div>
                            <div class="ps-5">
                              <div class="card mb-2" v-for="(y, yIndex) in filteredTarget(kpi)" :key="`target-${y.id}`">
                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                  :keyId="`${tabIndex}-DU${selectedDu.deliveryUnitId}-${type}-KPI${kpi.indicatorItemId}-Target${y.id}`" />
                                <div class="px-3 py-2">
                                  <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                      <div class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        style="min-width: 30px">
                                        <h3 class="mb-0 position-relative">
                                          {{ yIndex + 1 }}
                                        </h3>
                                      </div>
                                      <div>
                                        <h5 class="mb-0">
                                          {{ y.remarks }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="ms-2" style="min-width: max-content">
                                      <button type="button" @click="returnTPMSFunc(y)" class="btn btn-sm btn-warning ms-2" v-if="!y.ratingScaleStatus || (y.ratingScaleStatus && !y.ratingScaleStatus.toLowerCase().includes('return'))">
                                        <i class="mdi mdi-arrow-left-circle fs-6"></i>
                                        Return TPMS
                                      </button>
                                      <button type="button" @click="postTarget(y)" class="btn btn-sm btn-success ms-2">
                                        <i class="mdi mdi-check fs-6"></i>
                                        Post Target
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </div>
                </b-tabs>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab @click="
          getPostedDu(
            $store.state.data.cycle,
            $store.state.data.selectedCampus.id
          );
        selectedDu = null;
        ">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">For Secretariat Review</span>
          </template>
          <div v-if="tabIndex == 1">
            <div class="d-flex align-items-center gap-2">
              <multiselect id="deliveryUnit" v-model="selectedDu" track-by="deliveryUnitId" label="deliveryUnitName"
                placeholder="Select Delivery Unit..." :show-labels="false" :options="duData" :searchable="true"
                :multiple="false" :allow-empty="false" :close-on-select="true" @input="openTargets(selectedDu)">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.deliveryUnitName
                    }}</span><span v-if="props.option.submittedCount"
                      class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                        props.option.submittedCount
                      }}</span>
                  </div>
                  <div class="option__label">
                    <small>{{ props.option.campusName }}</small>
                  </div>
                </template>
              </multiselect>
              <!-- Print OPCR By Filter UI Button and Popover -->
              <div>
                <button type="button" class="btn btn-purple" :id="`select-report-${tabIndex}`" @click="renderSelection"
                  style="min-width: 170px !important;">
                  <i class="bx bx-printer me-1"></i>Print OPCR By Filter
                </button>
                <b-popover :target="`select-report-${tabIndex}`" triggers="click" placement="left"
                  :show.sync="filteredReport" custom-class="popover-report">
                  <template v-slot:title>
                    <div class="d-flex align-items-center justify-content-between" style="color: #222736">
                      <span>Filter</span>
                      <span class="bx bx-x font-size-14 cursor-pointer" @click="filteredReport = false"></span>
                    </div>
                  </template>
                  <div class="p-3">
                    <div class="mb-2">
                      <div class="mb-1">Print Report By</div>
                      <div class="mb-2">
                        <div class="d-flex gap-3">
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCampus"
                              value="Campus" v-model="printType" />
                            <label class="form-check-label" for="printTypeCampus">
                              {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCluster"
                              value="Cluster" v-model="printType" />
                            <label class="form-check-label" for="printTypeCluster">
                              Cluster
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypePrexc"
                              value="PREXC" v-model="printType" />
                            <label class="form-check-label" for="printTypePrexc">
                              PREXC Classification
                            </label>
                          </div>
                        </div>
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" name="printType" id="printTypeSD" value="SubmissionDates"
                            v-model="printType" />
                          <label class="form-check-label" for="printTypeSD">
                            Submission Dates
                          </label>
                        </div>
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" name="printType" id="printTypeSum" value="Summary"
                            v-model="printType" />
                          <label class="form-check-label" for="printTypeSum">
                            Summary
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                      <multiselect id="campus" v-model="selectedCampusPrint" track-by="Id" label="CampusName"
                        :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :show-labels="true" :options="campusList" :searchable="true"
                        :multiple="printType === 'Cluster' ? true : false" :allow-empty="false"
                        :close-on-select="printType === 'Cluster' ? false : true" @input="
                          selectedClassificationPrint = null;
                        selectedPrexcPrint = [];
                        ">
                      </multiselect>
                    </div>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'Cluster'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">Cluster</div>
                          <multiselect id="cluster" v-model="selectedClusterPrint" track-by="clusterName"
                            label="clusterName" placeholder="Select Cluster..." :show-labels="true"
                            :options="clusterOptions" :searchable="true" :multiple="false" :allow-empty="false"
                            :close-on-select="true">
                          </multiselect>
                        </div>
                      </div>
                    </b-collapse>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'PREXC'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">PREXC Classification</div>
                          <multiselect id="classification" v-model="selectedClassificationPrint" track-by="id"
                            label="classification" placeholder="Select PREXC Classification..." :show-labels="true"
                            :options="groupedPrexc" :searchable="true" :multiple="false" :allow-empty="true"
                            :close-on-select="true" @input="selectedPrexcPrint = []">
                          </multiselect>
                        </div>
                        <b-collapse :visible="selectedClassificationPrint != null">
                          <div v-if="selectedClassificationPrint != null" class="mb-2">
                            <div class="mb-1">PREXC</div>
                            <multiselect id="prexc" v-model="selectedPrexcPrint" track-by="id" label="prexcName"
                              placeholder="Select PREXC..." :show-labels="true"
                              :options="selectedClassificationPrint.prexcList" :searchable="true" :multiple="true"
                              :allow-empty="true" :close-on-select="false">
                            </multiselect>
                          </div>
                        </b-collapse>
                      </div>
                    </b-collapse>
                    <hr />
                    <button @click="printFilteredRatedOPCR()" type="button" class="btn btn-purple btn-sm btn-block">
                      <span class="font-size-13">
                        <i class="bx bx-printer me-1"></i>
                        Print Report
                      </span>
                    </button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div v-if="!selectedDu" class="mt-2">
              <b-alert :show="true" variant="info">
                <div>Please select a Delivery Unit.</div>
              </b-alert>
            </div>
            <div class="mt-2 pt-2" v-else>
              <div class="p-3 d-flex align-items-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div v-else class="position-relative">
                <div class="text-right position-absolute" style="right: 0">
                  <div class="d-flex align-items-center gap-2">
                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                      menu-class="dropdown-menu-end" no-caret>
                      <template #button-content>
                        <i class="bx bx-printer me-1"></i>
                        Reports
                      </template>
                      <b-dropdown-item @click="printTPMS(selectedDu.deliveryUnitId)">TPMS</b-dropdown-item>
                      <b-dropdown-item @click="printRatedOPCR(selectedDu.deliveryUnitId)">Rated OPCR</b-dropdown-item>
                    </b-dropdown>
                    <div id="tickets-table_filter" class="dataTables_filter">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input autocomplete="off" v-model="filter" type="search"
                          placeholder="Search KPI, Target..." class="form-control form-control-sm"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <b-tabs content-class="py-3 text-muted" v-model="selectedDu.tabIndex" nav-class="nav-tabs-custom">
                  <div v-for="(type, index) in tabOptions" :key="index">
                    <b-tab v-if="checkTab(type)" class="position-relative" @click="
                      filter = '';
                    selectedDu.tabSelect = type;
                    ">
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="mdi mdi-clock-time-four-outline"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">
                          {{ type }}
                          <span v-if="typeNotifCount(type) > 0">({{ typeNotifCount(type) }})</span>
                        </span>
                      </template>
                      <div v-if="selectedDu.tabSelect == type">
                        <div v-if="filteredKpi(type).length == 0" class="text-center">
                          <h5 v-if="filter">Search not found</h5>
                          <h5 v-else>No data available</h5>
                        </div>
                        <div role="tablist" v-for="kpi in filteredKpi(type)" :key="kpi.indicatorItemId">
                          <div class="border-bottom pb-3 mb-3">
                            <div class="d-flex align-items-center pb-3">
                              <div style="
                                  width: 10px;
                                  height: 10px;
                                  border-radius: 50%;
                                " class="bg-success ms-2 me-3"></div>
                              <b class="font-size-14">
                                KPI: {{ kpi.indicatorItemName }}
                              </b>
                            </div>
                            <div class="ps-5">
                              <div class="card mb-2" v-for="(y, yIndex) in filteredTarget(kpi)" :key="`target-${y.id}`">
                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                  :keyId="`${tabIndex}-DU${selectedDu.deliveryUnitId}-${type}-KPI${kpi.indicatorItemId}-Target${y.id}`" />
                                <div class="px-3 py-2">
                                  <div class="d-flex justify-content-between" :class="{
                                    'mb-3': y.showDetails,
                                  }">
                                    <div class="d-flex align-items-center">
                                      <div class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        style="min-width: 30px">
                                        <h3 class="mb-0 position-relative">
                                          {{ yIndex + 1 }}
                                        </h3>
                                      </div>
                                      <div>
                                        <h5 class="mb-0">
                                          {{ y.remarks }}
                                        </h5>
                                        <div class="d-flex align-items-center">
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-warning d-flex align-items-center"
                                                @click="viewActualAPIs(y)">
                                                View API's
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-info d-flex align-items-center" @click="
                                                  y.showDetails = !y.showDetails
                                                  ">
                                                View Submissions
                                              </a>
                                            </small>
                                          </div>
                                          <span v-if="
                                            y.ratingScaleStatus == 'POSTED' ||
                                            type ==
                                            'Mandatory Support Function'
                                          " class="mx-2">|</span>
                                          <div v-if="
                                            y.ratingScaleStatus == 'POSTED' ||
                                            type ==
                                            'Mandatory Support Function'
                                          ">
                                            <small><a href="javascript: void(0);"
                                                class="text-pink d-flex align-items-center" @click="
                                                  getPerformanceRating(
                                                    y,
                                                    type ==
                                                      'Mandatory Support Function'
                                                      ? 'planning mandatory'
                                                      : 'planning'
                                                  )
                                                  ">
                                                View Performance Rubric
                                              </a>
                                            </small>
                                          </div>
                                          <span v-if="
                                            (y.actual.length &&
                                              y.actual[0].jsonRemarks != '' &&
                                              y.actual[0].jsonRemarks !=
                                              null) ||
                                            y.targetLogs.length > 0
                                          " class="mx-2">|</span>
                                          <div v-if="
                                            (y.actual.length &&
                                              y.actual[0].jsonRemarks != '' &&
                                              y.actual[0].jsonRemarks !=
                                              null) ||
                                            y.targetLogs.length > 0
                                          ">
                                            <small><a href="javascript: void(0);"
                                                class="text-muted d-flex align-items-center" @click="
                                                  viewReturnRamarks(
                                                    y.actual.length &&
                                                    y.actual[0].jsonRemarks,
                                                    y.targetLogs
                                                  )
                                                  ">
                                                View Logs
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-purple d-flex align-items-center"
                                                @click="getAttachments(y)">
                                                <i class="bx bx-paperclip"></i>
                                                Attachments
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="
                                      checkDuplicate(y) ||
                                      y.status == 'PENDING'
                                    " class="float-end ms-2" style="min-width: max-content">
                                      <button type="button" @click="deleteDuplicateTarget(y)"
                                        class="btn btn-sm btn-danger mb-2 ms-2">
                                        <i class="mdi mdi-trash-can fs-6"></i>
                                        Delete Target
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row" v-if="y.showDetails">
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <div class="float-end">
                                                <button v-if="
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q1PostedBy
                                                " type="button" class="btn btn-link btn-sm p-0 text-warning" @click="
                                                  unpostQuarter(y, selectedDu, 1)
                                                  ">
                                                  <i class="mdi mdi-undo-variant"></i>
                                                  Return
                                                </button>
                                              </div>
                                              <h5 class="card-title mb-0">
                                                Quarter 1
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q1PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(
                                                  1,
                                                  y.id,
                                                  type
                                                )
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q1 + "%"
                                                : y.q1
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q1 + "%"
                                                : y.actual[0].q1
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q1Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <div class="float-end">
                                                <button v-if="
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q2PostedBy
                                                " type="button" class="btn btn-link btn-sm p-0 text-warning" @click="
                                                  unpostQuarter(y, selectedDu, 2)
                                                  ">
                                                  <i class="mdi mdi-undo-variant"></i>
                                                  Return
                                                </button>
                                              </div>
                                              <h5 class="card-title mb-0">
                                                Quarter 2
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q2PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(
                                                  2,
                                                  y.id,
                                                  type
                                                )
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q2 + "%"
                                                : y.q2
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q2 + "%"
                                                : y.actual[0].q2
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q2Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <div class="float-end">
                                                <button v-if="
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q3PostedBy
                                                " type="button" class="btn btn-link btn-sm p-0 text-warning" @click="
                                                  unpostQuarter(y, selectedDu, 3)
                                                  ">
                                                  <i class="mdi mdi-undo-variant"></i>
                                                  Return
                                                </button>
                                              </div>
                                              <h5 class="card-title mb-0 p-0">
                                                Quarter 3
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q3PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(
                                                  3,
                                                  y.id,
                                                  type
                                                )
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q3 + "%"
                                                : y.q3
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q3 + "%"
                                                : y.actual[0].q3
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q3Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <div class="float-end">
                                                <button v-if="
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q4PostedBy
                                                " type="button" class="btn btn-link btn-sm p-0 text-warning" @click="
                                                  unpostQuarter(y, selectedDu, 4)
                                                  ">
                                                  <i class="mdi mdi-undo-variant"></i>
                                                  Return
                                                </button>
                                              </div>
                                              <h5 class="card-title mb-0">
                                                Quarter 4
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q4PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(
                                                  4,
                                                  y.id,
                                                  type
                                                )
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q4 + "%"
                                                : y.q4
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q4 + "%"
                                                : y.actual[0].q4
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q4Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mt-3" v-if="
                                    y.showDetails &&
                                    ((y.actual.length > 0 &&
                                      y.actual[0].status == 'POSTED') ||
                                      y.actual[0].status == 'RETURNED' ||
                                      checkDeadline(selectedDu))
                                  ">
                                    <div class="col-md-6">
                                      <div class="row mb-3">
                                        <div class="col-md-6">
                                          <label>
                                            Submitted On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{ getInitialDate(y) }}
                                          </div>
                                        </div>
                                        <div class="col-md-6">
                                          <label>
                                            Finalized On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else-if="
                                            y.actual.length > 0 &&
                                            y.actual[0].status == 'RETURNED'
                                          " style="white-space: break-spaces" class="form-control text-warning">
                                            Deadline
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{
                                              formatDateWithTime(
                                                new Date(y.actual[0].datePosted)
                                              )
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label class="m-0">Self Rating</label>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-size-11">Effectiveness / Quality</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Efficiency</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Timeliness</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Average</label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{ y.scoreQuality.toString() }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{ y.scoreEfficiency.toString() }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{ y.scoreTimeliness.toString() }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                calcAve(
                                                  y.scoreQuality,
                                                  y.scoreEfficiency,
                                                  y.scoreTimeliness
                                                ).toString()
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`finalRemarks${y.actual[0].id}`">Final Remarks</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].finalRemarks.toString()
                                          }}
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`catchupPlans${y.actual[0].id}`">
                                          <div>
                                            Catchup Plans / Justification
                                          </div>
                                          <div>
                                            <a href="javascript: void(0);"
                                              class="d-flex align-items-center font-size-12" @click="
                                                viewCatchupAttachment(y.id)
                                                ">
                                              <i class="bx bx-paperclip"></i>
                                              View Attachments
                                            </a>
                                          </div>
                                        </label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].catchUpPlans.toString()
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="border mb-3 p-3">
                                        <div class="mb-3">
                                          <div class="row">
                                            <div class="col-md-6">
                                              <label>Annual Target</label>
                                              <div class="d-flex align-items-center">
                                                <masked-input type="text" class="form-control w-100"
                                                  placeholder="Annual Target" v-model="y.annualTarget"
                                                  :mask="currencyMask"></masked-input>
                                                <b v-if="
                                                  y.mainTarget.isPercentage
                                                " class="ms-2">%</b>
                                              </div>
                                            </div>
                                            <div class="col-md-6">
                                              <label>Actual Accomplishment</label>
                                              <div class="d-flex align-items-center">
                                                <masked-input type="text" class="form-control w-100"
                                                  placeholder="Annual Target" v-model="y.actualAccomplishment
                                                    " :mask="currencyMask"></masked-input>
                                                <b v-if="
                                                  y.mainTarget.isPercentage
                                                " class="ms-2">%</b>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="mb-3">
                                          <label :for="`planningFeedback${y.actual[0].id}`">Validator's
                                            Feedback</label>
                                          <b-form-select class="form-select" v-model="y.planningFeedback">
                                            <b-form-select-option value="" disabled>Validator's
                                              Feedback...</b-form-select-option>
                                            <b-form-select-option value=""></b-form-select-option>
                                            <b-form-select-option value="LSD">Lacking supporting documents
                                              (LSD)</b-form-select-option>
                                            <b-form-select-option value="NTI">No Target Indicated
                                              (NTI)</b-form-select-option>
                                            <b-form-select-option value="NAI">No Accomplishment Indicated
                                              (NAI)</b-form-select-option>
                                            <b-form-select-option value="AIT">Accomplishment Inconsistent with
                                              Target (AIT)</b-form-select-option>
                                            <b-form-select-option value="ES">Evidence Sufficient
                                              (ES)</b-form-select-option>
                                            <b-form-select-option value="EIS">Evidence Insufficient
                                              (EIS)</b-form-select-option>
                                            <b-form-select-option value="LSE">Label Submitted Evidence
                                              (LSE)</b-form-select-option>
                                            <b-form-select-option value="NEA">No Evidence Attached
                                              (NEA)</b-form-select-option>
                                            <b-form-select-option value="NAVI">No Absolute Value Indicated
                                              (NAVI)</b-form-select-option>
                                            <b-form-select-option value="KNF">KPI not found in approved OPCR
                                              (KNF)</b-form-select-option>
                                            <b-form-select-option value="KFD">KPI Found in approved OPCR but
                                              Deleted
                                              (KFD)</b-form-select-option>
                                            <b-form-select-option value="FPD">For PMTs Deliberation
                                              (FPD)</b-form-select-option>
                                            <b-form-select-option value="WDRA">Wrong Dimension Rating (QET) as Agreed (WDRA)</b-form-select-option>
                                          </b-form-select>
                                        </div>
                                        <div>
                                          <label :for="`planningRemarks${y.actual[0].id}`">Validator's Remarks</label>
                                          <textarea id="" rows="3" class="form-control" v-model="y.planningRemarks"
                                            placeholder="Enter Remarks" />
                                        </div>
                                      </div>
                                      <div class="d-flex float-end gap-2 mb-3">
                                        <button v-if="
                                          y.actual.length > 0 &&
                                          y.actual[0].status != 'RETURNED'
                                        " type="button" @click="returnTarget(y, selectedDu)" class="btn btn-warning">
                                          <i class="mdi mdi-undo-variant me-1"></i>Return
                                        </button>
                                        <button type="button" @click="updateTarget(y, true)" class="btn btn-info">
                                          <i class="bx bx-save me-1"></i>Save
                                          Feedback
                                        </button>
                                        <button type="button" @click="submitTarget(y)" class="btn btn-success">
                                          <i class="bx bx-check me-1"></i>Save &
                                          Send for PMT Rating
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </div>
                </b-tabs>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab @click="
          getSubmittedDu(
            $store.state.data.cycle,
            $store.state.data.selectedCampus.id
          );
        selectedDu = null;
        ">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">For PMT Rating</span>
          </template>
          <div v-if="tabIndex == 2">
            <div class="d-flex align-items-center gap-2">
              <multiselect id="deliveryUnit" v-model="selectedDu" track-by="deliveryUnitId" label="deliveryUnitName"
                placeholder="Select Delivery Unit..." :show-labels="false" :options="duData" :searchable="true"
                :multiple="false" :allow-empty="false" :close-on-select="true" @input="openTargets(selectedDu)">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.deliveryUnitName
                    }}</span><span v-if="props.option.submittedCount"
                      class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                        props.option.submittedCount
                      }}</span>
                  </div>
                  <div class="option__label">
                    <small>{{ props.option.campusName }}</small>
                  </div>
                </template>
              </multiselect>
              <!-- Print OPCR By Filter UI Button and Popover -->
              <div>
                <button type="button" class="btn btn-purple" :id="`select-report-${tabIndex}`" @click="renderSelection"
                  style="min-width: 170px !important;">
                  <i class="bx bx-printer me-1"></i>Print OPCR By Filter
                </button>
                <b-popover :target="`select-report-${tabIndex}`" triggers="click" placement="left"
                  :show.sync="filteredReport" custom-class="popover-report">
                  <template v-slot:title>
                    <div class="d-flex align-items-center justify-content-between" style="color: #222736">
                      <span>Filter</span>
                      <span class="bx bx-x font-size-14 cursor-pointer" @click="filteredReport = false"></span>
                    </div>
                  </template>
                  <div class="p-3">
                    <div class="mb-2">
                      <div class="mb-1">Print Report By</div>
                      <div class="mb-2">
                        <div class="d-flex gap-3">
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCampus"
                              value="Campus" v-model="printType" />
                            <label class="form-check-label" for="printTypeCampus">
                              {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCluster"
                              value="Cluster" v-model="printType" />
                            <label class="form-check-label" for="printTypeCluster">
                              Cluster
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypePrexc"
                              value="PREXC" v-model="printType" />
                            <label class="form-check-label" for="printTypePrexc">
                              PREXC Classification
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSD" value="SubmissionDates"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSD">
                              Submission Dates
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSum" value="Summary"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSum">
                              Summary
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                      <multiselect id="campus" v-model="selectedCampusPrint" track-by="Id" label="CampusName"
                        :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :show-labels="true" :options="campusList" :searchable="true"
                        :multiple="printType === 'Cluster' ? true : false" :allow-empty="false"
                        :close-on-select="printType === 'Cluster' ? false : true" @input="
                          selectedClassificationPrint = null;
                        selectedPrexcPrint = [];
                        ">
                      </multiselect>
                    </div>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'Cluster'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">Cluster</div>
                          <multiselect id="cluster" v-model="selectedClusterPrint" track-by="clusterName"
                            label="clusterName" placeholder="Select Cluster..." :show-labels="true"
                            :options="clusterOptions" :searchable="true" :multiple="false" :allow-empty="false"
                            :close-on-select="true">
                          </multiselect>
                        </div>
                      </div>
                    </b-collapse>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'PREXC'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">PREXC Classification</div>
                          <multiselect id="classification" v-model="selectedClassificationPrint" track-by="id"
                            label="classification" placeholder="Select PREXC Classification..." :show-labels="true"
                            :options="groupedPrexc" :searchable="true" :multiple="false" :allow-empty="true"
                            :close-on-select="true" @input="selectedPrexcPrint = []">
                          </multiselect>
                        </div>
                        <b-collapse :visible="selectedClassificationPrint != null">
                          <div v-if="selectedClassificationPrint != null" class="mb-2">
                            <div class="mb-1">PREXC</div>
                            <multiselect id="prexc" v-model="selectedPrexcPrint" track-by="id" label="prexcName"
                              placeholder="Select PREXC..." :show-labels="true"
                              :options="selectedClassificationPrint.prexcList" :searchable="true" :multiple="true"
                              :allow-empty="true" :close-on-select="false">
                            </multiselect>
                          </div>
                        </b-collapse>
                      </div>
                    </b-collapse>
                    <hr />
                    <button @click="printFilteredRatedOPCR()" type="button" class="btn btn-purple btn-sm btn-block">
                      <span class="font-size-13">
                        <i class="bx bx-printer me-1"></i>
                        Print Report
                      </span>
                    </button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div v-if="!selectedDu" class="mt-2">
              <b-alert :show="true" variant="info">
                <div>Please select a Delivery Unit.</div>
              </b-alert>
            </div>
            <div class="mt-2 pt-2" v-else>
              <div class="p-3 d-flex align-items-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div v-else class="position-relative">
                <div class="text-right position-absolute" style="right: 0">
                  <div class="d-flex align-items-center gap-2">
                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                      menu-class="dropdown-menu-end" no-caret>
                      <template #button-content>
                        <i class="bx bx-printer me-1"></i>
                        Reports
                      </template>
                      <b-dropdown-item @click="printTPMS(selectedDu.deliveryUnitId)">TPMS</b-dropdown-item>
                      <b-dropdown-item @click="printRatedOPCR(selectedDu.deliveryUnitId)">Rated OPCR</b-dropdown-item>
                    </b-dropdown>
                    <div id="tickets-table_filter" class="dataTables_filter">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input autocomplete="off" v-model="filter" type="search"
                          placeholder="Search KPI, Target..." class="form-control form-control-sm"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <b-tabs content-class="py-3 text-muted" v-model="selectedDu.tabIndex" nav-class="nav-tabs-custom">
                  <div v-for="(type, index) in tabOptions" :key="index">
                    <b-tab v-if="checkTab(type)" class="position-relative" @click="
                      filter = '';
                    selectedDu.tabSelect = type;
                    ">
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="mdi mdi-clock-time-four-outline"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">
                          {{ type }}
                          <span v-if="typeNotifCount(type) > 0">({{ typeNotifCount(type) }})</span>
                        </span>
                      </template>
                      <div v-if="selectedDu.tabSelect == type">
                        <div v-if="filteredKpi(type).length == 0" class="text-center">
                          <h5 v-if="filter">Search not found</h5>
                          <h5 v-else>No data available</h5>
                        </div>
                        <div role="tablist" v-for="kpi in filteredKpi(type)" :key="kpi.indicatorItemId">
                          <div class="border-bottom pb-3 mb-3">
                            <div class="d-flex align-items-center pb-3">
                              <div style="
                                  width: 10px;
                                  height: 10px;
                                  border-radius: 50%;
                                " class="bg-success ms-2 me-3"></div>
                              <b class="font-size-14">
                                KPI: {{ kpi.indicatorItemName }}
                              </b>
                            </div>
                            <div class="ps-5">
                              <div class="card mb-2" v-for="(y, yIndex) in filteredTarget(kpi)" :key="`target-${y.id}`">
                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                  :keyId="`${tabIndex}-DU${selectedDu.deliveryUnitId}-${type}-KPI${kpi.indicatorItemId}-Target${y.id}`" />
                                <div class="px-3 py-2">
                                  <div class="d-flex justify-content-between" :class="{
                                    'mb-3': y.showDetails,
                                  }">
                                    <div class="d-flex align-items-center">
                                      <div class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        style="min-width: 30px">
                                        <h3 class="mb-0 position-relative">
                                          {{ yIndex + 1 }}
                                        </h3>
                                      </div>
                                      <div>
                                        <h5 class="mb-0">
                                          {{ y.remarks }}
                                        </h5>
                                        <div class="d-flex align-items-center">
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-warning d-flex align-items-center"
                                                @click="viewActualAPIs(y)">
                                                View API's
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-info d-flex align-items-center" @click="
                                                  y.showDetails = !y.showDetails
                                                  ">
                                                View Submissions
                                              </a>
                                            </small>
                                          </div>
                                          <span v-if="
                                            y.ratingScaleStatus == 'POSTED'
                                          " class="mx-2">|</span>
                                          <div v-if="
                                            y.ratingScaleStatus == 'POSTED'
                                          ">
                                            <small><a href="javascript: void(0);"
                                                class="text-pink d-flex align-items-center" @click="
                                                  getPerformanceRating(y, 'pmt')
                                                  ">
                                                View Performance Rubric
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-muted d-flex align-items-center" @click="
                                                  viewReturnRamarks(
                                                    y.actual.length &&
                                                    y.actual[0].jsonRemarks,
                                                    y.targetLogs
                                                  )
                                                  ">
                                                View Logs
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-purple d-flex align-items-center"
                                                @click="getAttachments(y)">
                                                <i class="bx bx-paperclip"></i>
                                                Attachments
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row" v-if="y.showDetails">
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 1
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q1PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(1, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q1 + "%"
                                                : y.q1
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q1 + "%"
                                                : y.actual[0].q1
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q1Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 2
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q2PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(2, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q2 + "%"
                                                : y.q2
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q2 + "%"
                                                : y.actual[0].q2
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q2Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0 p-0">
                                                Quarter 3
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q3PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(3, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q3 + "%"
                                                : y.q3
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q3 + "%"
                                                : y.actual[0].q3
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q3Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 4
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q4PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(4, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q4 + "%"
                                                : y.q4
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q4 + "%"
                                                : y.actual[0].q4
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q4Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mt-3" v-if="
                                    y.showDetails &&
                                    ((y.actual.length > 0 &&
                                      y.actual[0].status == 'POSTED') ||
                                      y.actual[0].status == 'RETURNED' ||
                                      checkDeadline(selectedDu))
                                  ">
                                    <div class="col-md-6">
                                      <div class="row mb-3">
                                        <div class="col-md-6">
                                          <label>
                                            Submitted On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{ getInitialDate(y) }}
                                          </div>
                                        </div>
                                        <div class="col-md-6">
                                          <label>
                                            Finalized On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else-if="
                                            y.actual.length > 0 &&
                                            y.actual[0].status == 'RETURNED'
                                          " style="white-space: break-spaces" class="form-control text-warning">
                                            Returned
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{
                                              formatDateWithTime(
                                                new Date(y.actual[0].datePosted)
                                              )
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <div class="row">
                                          <div class="col-md-6">
                                            <label>Annual Target</label>
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.annualTarget
                                                  ? y.annualTarget
                                                  : getAnnualTarget(
                                                    y,
                                                    y.mainTarget.isPercentage
                                                  ).toString()
                                              }}{{
                                                y.mainTarget.isPercentage
                                                  ? "%"
                                                  : ""
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <label>Actual Accomplishment</label>
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.actualAccomplishment
                                                  ? y.actualAccomplishment
                                                  : 0
                                              }}{{
                                                y.mainTarget.isPercentage
                                                  ? "%"
                                                  : ""
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`finalRemarks${y.actual[0].id}`">Final Remarks</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].finalRemarks.toString()
                                          }}
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`catchupPlans${y.actual[0].id}`">
                                          <div>
                                            Catchup Plans / Justification
                                          </div>
                                          <div>
                                            <a href="javascript: void(0);"
                                              class="d-flex align-items-center font-size-12" @click="
                                                viewCatchupAttachment(y.id)
                                                ">
                                              <i class="bx bx-paperclip"></i>
                                              View Attachments
                                            </a>
                                          </div>
                                        </label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].catchUpPlans.toString()
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <label>Validator's Feedback</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            validatorFeedback(
                                              y.planningFeedback
                                            )
                                          }}
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label>Validator's Remarks</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{ y.planningRemarks }}
                                        </div>
                                      </div>
                                      <div v-if="!y.isNotApplicable" class="mb-3">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="m-0 font-size-12">Effectiveness / Quality</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Efficiency</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Timeliness</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Average</label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreQuality }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreEfficiency }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreTimeliness }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{
                                                  calcAve(
                                                    y.scoreQuality,
                                                    y.scoreEfficiency,
                                                    y.scoreTimeliness
                                                  )
                                                }}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreQuality.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreEfficiency.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreTimeliness.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                calcAve(
                                                  y.evaluationScoreQuality,
                                                  y.evaluationScoreEfficiency,
                                                  y.evaluationScoreTimeliness
                                                ).toString()
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else class="mb-3">
                                        <label>QET Rating</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          N/A
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </div>
                </b-tabs>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab @click="
          getCompletedDu(
            $store.state.data.cycle,
            $store.state.data.selectedCampus.id
          );
        selectedDu = null;
        ">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Completed Review</span>
          </template>
          <div v-if="tabIndex == 3">
            <div class="d-flex align-items-center gap-2">
              <multiselect id="deliveryUnit" v-model="selectedDu" track-by="deliveryUnitId" label="deliveryUnitName"
                placeholder="Select Delivery Unit..." :show-labels="false" :options="duData" :searchable="true"
                :multiple="false" :allow-empty="false" :close-on-select="true" @input="openTargets(selectedDu)">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.deliveryUnitName
                    }}</span><span v-if="props.option.submittedCount"
                      class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                        props.option.submittedCount
                      }}</span>
                  </div>
                  <div class="option__label">
                    <small>{{ props.option.campusName }}</small>
                  </div>
                </template>
              </multiselect>
              <!-- Print OPCR By Filter UI Button and Popover -->
              <div>
                <button type="button" class="btn btn-purple" :id="`select-report-${tabIndex}`" @click="renderSelection"
                  style="min-width: 170px !important;">
                  <i class="bx bx-printer me-1"></i>Print OPCR By Filter
                </button>
                <b-popover :target="`select-report-${tabIndex}`" triggers="click" placement="left"
                  :show.sync="filteredReport" custom-class="popover-report">
                  <template v-slot:title>
                    <div class="d-flex align-items-center justify-content-between" style="color: #222736">
                      <span>Filter</span>
                      <span class="bx bx-x font-size-14 cursor-pointer" @click="filteredReport = false"></span>
                    </div>
                  </template>
                  <div class="p-3">
                    <div class="mb-2">
                      <div class="mb-1">Print Report By</div>
                      <div class="mb-2">
                        <div class="d-flex gap-3">
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCampus"
                              value="Campus" v-model="printType" />
                            <label class="form-check-label" for="printTypeCampus">
                              {{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }}
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeCluster"
                              value="Cluster" v-model="printType" />
                            <label class="form-check-label" for="printTypeCluster">
                              Cluster
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypePrexc"
                              value="PREXC" v-model="printType" />
                            <label class="form-check-label" for="printTypePrexc">
                              PREXC Classification
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSD" value="SubmissionDates"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSD">
                              Submission Dates
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="printType" id="printTypeSum" value="Summary"
                              v-model="printType" />
                            <label class="form-check-label" for="printTypeSum">
                              Summary
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                      <multiselect id="campus" v-model="selectedCampusPrint" track-by="Id" label="CampusName"
                        :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :show-labels="true" :options="campusList" :searchable="true"
                        :multiple="printType === 'Cluster' ? true : false" :allow-empty="false"
                        :close-on-select="printType === 'Cluster' ? false : true" @input="
                          selectedClassificationPrint = null;
                        selectedPrexcPrint = [];
                        ">
                      </multiselect>
                    </div>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'Cluster'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">Cluster</div>
                          <multiselect id="cluster" v-model="selectedClusterPrint" track-by="clusterName"
                            label="clusterName" placeholder="Select Cluster..." :show-labels="true"
                            :options="clusterOptions" :searchable="true" :multiple="false" :allow-empty="false"
                            :close-on-select="true">
                          </multiselect>
                        </div>
                      </div>
                    </b-collapse>
                    <b-collapse :visible="selectedCampusPrint != null && printType === 'PREXC'">
                      <div v-if="selectedCampusPrint != null">
                        <hr />
                        <div class="mb-2">
                          <div class="mb-1">PREXC Classification</div>
                          <multiselect id="classification" v-model="selectedClassificationPrint" track-by="id"
                            label="classification" placeholder="Select PREXC Classification..." :show-labels="true"
                            :options="groupedPrexc" :searchable="true" :multiple="false" :allow-empty="true"
                            :close-on-select="true" @input="selectedPrexcPrint = []">
                          </multiselect>
                        </div>
                        <b-collapse :visible="selectedClassificationPrint != null">
                          <div v-if="selectedClassificationPrint != null" class="mb-2">
                            <div class="mb-1">PREXC</div>
                            <multiselect id="prexc" v-model="selectedPrexcPrint" track-by="id" label="prexcName"
                              placeholder="Select PREXC..." :show-labels="true"
                              :options="selectedClassificationPrint.prexcList" :searchable="true" :multiple="true"
                              :allow-empty="true" :close-on-select="false">
                            </multiselect>
                          </div>
                        </b-collapse>
                      </div>
                    </b-collapse>
                    <hr />
                    <button @click="printFilteredRatedOPCR()" type="button" class="btn btn-purple btn-sm btn-block">
                      <span class="font-size-13">
                        <i class="bx bx-printer me-1"></i>
                        Print Report
                      </span>
                    </button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div v-if="!selectedDu" class="mt-2">
              <b-alert :show="true" variant="info">
                <div>Please select a Delivery Unit.</div>
              </b-alert>
            </div>
            <div class="mt-2 pt-2" v-else>
              <div class="p-3 d-flex align-items-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div v-else class="position-relative">
                <div class="text-right position-absolute" style="right: 0">
                  <div class="d-flex align-items-center gap-2">
                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                      menu-class="dropdown-menu-end" no-caret>
                      <template #button-content>
                        <i class="bx bx-printer me-1"></i>
                        Reports
                      </template>
                      <b-dropdown-item @click="printTPMS(selectedDu.deliveryUnitId)">TPMS</b-dropdown-item>
                      <b-dropdown-item @click="printRatedOPCR(selectedDu.deliveryUnitId)">Rated OPCR</b-dropdown-item>
                    </b-dropdown>
                    <div id="tickets-table_filter" class="dataTables_filter">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input autocomplete="off" v-model="filter" type="search"
                          placeholder="Search KPI, Target..." class="form-control form-control-sm"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <b-tabs content-class="py-3 text-muted" v-model="selectedDu.tabIndex" nav-class="nav-tabs-custom">
                  <div v-for="(type, index) in tabOptions" :key="index">
                    <b-tab v-if="checkTab(type)" class="position-relative" @click="
                      filter = '';
                    selectedDu.tabSelect = type;
                    ">
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="mdi mdi-clock-time-four-outline"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">
                          {{ type }}
                          <span v-if="typeNotifCount(type) > 0">({{ typeNotifCount(type) }})</span>
                        </span>
                      </template>
                      <div v-if="selectedDu.tabSelect == type">
                        <div v-if="filteredKpi(type).length == 0" class="text-center">
                          <h5 v-if="filter">Search not found</h5>
                          <h5 v-else>No data available</h5>
                        </div>
                        <div role="tablist" v-for="kpi in filteredKpi(type)" :key="kpi.indicatorItemId">
                          <div class="border-bottom pb-3 mb-3">
                            <div class="d-flex align-items-center pb-3">
                              <div style="
                                  width: 10px;
                                  height: 10px;
                                  border-radius: 50%;
                                " class="bg-success ms-2 me-3"></div>
                              <b class="font-size-14">
                                KPI: {{ kpi.indicatorItemName }}
                              </b>
                            </div>
                            <div class="ps-5">
                              <div class="card mb-2" v-for="(y, yIndex) in filteredTarget(kpi)" :key="`target-${y.id}`">
                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                  :keyId="`${tabIndex}-DU${selectedDu.deliveryUnitId}-${type}-KPI${kpi.indicatorItemId}-Target${y.id}`" />
                                <div class="px-3 py-2">
                                  <div class="d-flex justify-content-between" :class="{
                                    'mb-3': y.showDetails,
                                  }">
                                    <div class="d-flex align-items-center">
                                      <div class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        style="min-width: 30px">
                                        <h3 class="mb-0 position-relative">
                                          {{ yIndex + 1 }}
                                        </h3>
                                      </div>
                                      <div>
                                        <h5 class="mb-0">
                                          {{ y.remarks }}
                                        </h5>
                                        <div class="d-flex align-items-center">
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-warning d-flex align-items-center"
                                                @click="viewActualAPIs(y)">
                                                View API's
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-info d-flex align-items-center" @click="
                                                  y.showDetails = !y.showDetails
                                                  ">
                                                View Submissions
                                              </a>
                                            </small>
                                          </div>
                                          <span v-if="
                                            y.ratingScaleStatus == 'POSTED'
                                          " class="mx-2">|</span>
                                          <div v-if="
                                            y.ratingScaleStatus == 'POSTED'
                                          ">
                                            <small><a href="javascript: void(0);"
                                                class="text-pink d-flex align-items-center" @click="
                                                  getPerformanceRating(y, 'pmt')
                                                  ">
                                                View Performance Rubric
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-muted d-flex align-items-center" @click="
                                                  viewReturnRamarks(
                                                    y.actual.length &&
                                                    y.actual[0].jsonRemarks,
                                                    y.targetLogs
                                                  )
                                                  ">
                                                View Logs
                                              </a>
                                            </small>
                                          </div>
                                          <span class="mx-2">|</span>
                                          <div>
                                            <small><a href="javascript: void(0);"
                                                class="text-purple d-flex align-items-center"
                                                @click="getAttachments(y)">
                                                <i class="bx bx-paperclip"></i>
                                                Attachments
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row" v-if="y.showDetails">
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 1
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q1PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(1, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q1PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q1 + "%"
                                                : y.q1
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q1 + "%"
                                                : y.actual[0].q1
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q1Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 2
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q2PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(2, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q2PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q2 + "%"
                                                : y.q2
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q2 + "%"
                                                : y.actual[0].q2
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q2Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0 p-0">
                                                Quarter 3
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q3PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(3, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q3PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q3 + "%"
                                                : y.q3
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q3 + "%"
                                                : y.actual[0].q3
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q3Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="card mb-0">
                                        <div class="card-header" :class="{
                                          'bg-success text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <div>
                                              <h5 class="card-title mb-0">
                                                Quarter 4
                                              </h5>
                                              <button type="button" class="btn btn-link btn-sm p-0" :class="{
                                                'text-white':
                                                  y.actual.length > 0 &&
                                                  y.actual[0].q4PostedBy,
                                              }" @click="
                                                viewQuarterAttachment(4, y.id)
                                                ">
                                                <i class="bx bx-paperclip"></i>
                                                View Mode of Verification
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card-body" :class="{
                                          'bg-success bg-soft text-white':
                                            y.actual.length > 0 &&
                                            y.actual[0].q4PostedBy,
                                        }">
                                          <div>
                                            <small>Target:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.q4 + "%"
                                                : y.q4
                                            }}
                                          </div>
                                          <div v-if="y.actual.length == 0">
                                            <small>Actual:</small>
                                            N/A
                                          </div>
                                          <div v-if="y.actual.length > 0">
                                            <small>Actual:</small>
                                            {{
                                              y.mainTarget.isPercentage
                                                ? y.actual[0].q4 + "%"
                                                : y.actual[0].q4
                                            }}
                                          </div>
                                          <div>
                                            <small>Remarks:</small>
                                            {{
                                              y.actual.length > 0
                                                ? y.actual[0].q4Remarks
                                                : "N/A"
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mt-3" v-if="
                                    y.showDetails &&
                                    ((y.actual.length > 0 &&
                                      y.actual[0].status == 'POSTED') ||
                                      y.actual[0].status == 'RETURNED' ||
                                      checkDeadline(selectedDu))
                                  ">
                                    <div class="col-md-6">
                                      <div class="row mb-3">
                                        <div class="col-md-6">
                                          <label>
                                            Submitted On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{ getInitialDate(y) }}
                                          </div>
                                        </div>
                                        <div class="col-md-6">
                                          <label>
                                            Finalized On
                                            <small v-if="
                                              y.actual.length > 0 &&
                                              y.actual[0].status != 'Pending' &&
                                              y.actual[0].status != 'RETURNED' &&
                                              !y.actual[0].q1PostedBy &&
                                              !y.actual[0].q2PostedBy &&
                                              !y.actual[0].q3PostedBy &&
                                              !y.actual[0].q4PostedBy
                                            " class="text-warning">
                                              (Posted by PMT Secretariat)
                                            </small>
                                          </label>
                                          <div v-if="
                                            y.actual.length == 0 ||
                                            (y.actual.length > 0 &&
                                              y.actual[0].status == 'Pending')
                                          " style="white-space: break-spaces" class="form-control text-danger">
                                            Not Posted
                                          </div>
                                          <div v-else-if="
                                            y.actual.length > 0 &&
                                            y.actual[0].status == 'RETURNED'
                                          " style="white-space: break-spaces" class="form-control text-warning">
                                            Returned
                                          </div>
                                          <div v-else style="white-space: break-spaces" class="form-control">
                                            {{
                                              formatDateWithTime(
                                                new Date(y.actual[0].datePosted)
                                              )
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <div class="row">
                                          <div class="col-md-6">
                                            <label>Annual Target</label>
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.annualTarget
                                                  ? y.annualTarget
                                                  : getAnnualTarget(
                                                    y,
                                                    y.mainTarget.isPercentage
                                                  ).toString()
                                              }}{{
                                                y.mainTarget.isPercentage
                                                  ? "%"
                                                  : ""
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <label>Actual Accomplishment</label>
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.actualAccomplishment
                                                  ? y.actualAccomplishment
                                                  : 0
                                              }}{{
                                                y.mainTarget.isPercentage
                                                  ? "%"
                                                  : ""
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`finalRemarks${y.actual[0].id}`">Final Remarks</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].finalRemarks.toString()
                                          }}
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label :for="`catchupPlans${y.actual[0].id}`">
                                          <div>
                                            Catchup Plans / Justification
                                          </div>
                                          <div>
                                            <a href="javascript: void(0);"
                                              class="d-flex align-items-center font-size-12" @click="
                                                viewCatchupAttachment(y.id)
                                                ">
                                              <i class="bx bx-paperclip"></i>
                                              View Attachments
                                            </a>
                                          </div>
                                        </label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            y.actual[0].catchUpPlans.toString()
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <label>Validator's Feedback</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{
                                            validatorFeedback(
                                              y.planningFeedback
                                            )
                                          }}
                                        </div>
                                      </div>
                                      <div class="mb-3">
                                        <label>Validator's Remarks</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          {{ y.planningRemarks }}
                                        </div>
                                      </div>
                                      <div v-if="!y.isNotApplicable" class="mb-3">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="m-0 font-size-12">Effectiveness / Quality</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Efficiency</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Timeliness</label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="m-0">Average</label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreQuality }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreEfficiency }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{ y.scoreTimeliness }}
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-md-3">
                                            <label class="font-size-11">Self Rating:
                                              <span class="text-info font-size-14">
                                                {{
                                                  calcAve(
                                                    y.scoreQuality,
                                                    y.scoreEfficiency,
                                                    y.scoreTimeliness
                                                  )
                                                }}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreQuality.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreEfficiency.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                y.evaluationScoreTimeliness.toString()
                                              }}
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div style="white-space: break-spaces" class="form-control">
                                              {{
                                                calcAve(
                                                  y.evaluationScoreQuality,
                                                  y.evaluationScoreEfficiency,
                                                  y.evaluationScoreTimeliness
                                                ).toString()
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else class="mb-3">
                                        <label>QET Rating</label>
                                        <div style="white-space: break-spaces" class="form-control">
                                          N/A
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </div>
                </b-tabs>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <RatingScale ref="RatingScale"></RatingScale>
    <attachment-modal :wActions="false" :title="uploadTitle" ref="attachmentModal"></attachment-modal>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.popover-report {
  min-width: 600px !important;
}
</style>
